import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import { classNames, EGDSContextProvider, validatePropType, EGDSContextWrapper, useEGDSContext, analyticsTracker, liveAnnounce, Level, MakeEgdsSizingLength as MakeEgdsSizingLength$1 } from '@egds/react-core/utils';
import styles from '../styles/egds-one-design-language-egds-local-theme-provider.css';
import styles$1 from '../styles/egds-one-design-language-egds-local-themed-badge.css';
import * as React from 'react';
import React__default from 'react';
import styles$2 from '../styles/egds-one-design-language-egds-local-themed-button.css';
import styles$3 from '../styles/egds-one-design-language-egds-local-themed-card.css';
import { EGDSIconSize, EGDSIcon } from '@egds/react-core/icons';
import styles$4 from '../styles/egds-one-design-language-egds-local-themed-icon.css';
import { EGDSSheet, EGDSSheetContent } from '@egds/react-core/sheet';
import styles$5 from '../styles/egds-one-design-language-egds-local-themed-sheet.css';
import styles$6 from '../styles/egds-one-design-language-egds-local-themed-text.css';
import styles$7 from '../styles/egds-one-design-language-shimmer.css';
import styles$8 from '../styles/egds-one-design-language-egds-team-block-link.css';
import styles$9 from '../styles/egds-one-design-language-egds-team-cards-border-radius-increase.css';
import { EGDSLayoutTags } from '@egds/react-core/layout';
import styles$a from '../styles/egds-one-design-language-egds-team-layout-grid-container-based-sizing.css';
import { useLocalization } from '@shared-ui/localization-context';
import { debounce } from 'throttle-debounce';
import styles$b from '../styles/egds-one-design-language-egds-team-carousel-refactor.css';
import { EGDSPagingPrevButton, EGDSPagingNextButton, EGDSPrimaryButton, EGDSButtonSize } from '@egds/react-core/button';
import styles$c from '../styles/egds-one-design-language-egds-team-images-refactor.css';
import styles$d from '../styles/egds-one-design-language-egds-team-scrim-refactor.css';
import styles$e from '../styles/egds-one-design-language-egds-team-text-breakpoint-sizing.css';
import { Player } from '@lottiefiles/react-lottie-player';
import styles$f from '../styles/egds-one-design-language-mark-animated.css';
import { Viewport, ViewMedium, ViewSmall } from '@shared-ui/viewport-context';
import { EGDSLayoutPosition } from '@egds/react-core/layout-position';
import { EGDSSpacing } from '@egds/react-core/spacing';
import { EGDSLayoutFlex, EGDSLayoutFlexItem } from '@egds/react-core/layout-flex';
import { EGDSBadgeStandardThemes, EGDSBadgeStandard } from '@egds/react-core/badge';
import { EGDSSubheading } from '@egds/react-core/text';
import { EGDSFigureAspectRatioType as EGDSFigureAspectRatioType$1 } from '@egds/react-core/images';
import { EGDSLayoutGrid, EGDSLayoutGridItem, MinMax as MinMax$1 } from '@egds/react-core/layout-grid';
import { EGDSCard } from '@egds/react-core/cards';

const getClassNameList$o = classNames.bind(styles);
const EGDSLocalThemeProvider = (props) => {
    const { config, children, enableDarkMode = false, isSection = false, style } = props;
    const themeClasses = getClassNameList$o(config.lightMode?.isBase ? 'light-mode-is-base' : 'light-mode-is-not-base', enableDarkMode ? (config.darkMode?.isBase ? 'dark-mode-is-base' : 'dark-mode-is-not-base') : '', config.lightMode?.isGradient && 'light-mode-is-gradient', enableDarkMode ? config.darkMode?.isGradient && 'dark-mode-is-gradient' : '');
    const sectionStyle = {
        background: 'var(--egds-background-color-base)',
        ...style,
    };
    let darkModeAttrs;
    if (typeof document !== 'undefined') {
        const addThemeAttributes = () => {
            if (!document.body.hasAttribute('data-light-theme')) {
                document.body.setAttribute('data-light-theme', 'light-1');
            }
            if (enableDarkMode && !document.body.hasAttribute('data-dark-theme')) {
                document.body.setAttribute('data-dark-theme', 'dark-1');
            }
        };
        // Auto-initialize
        addThemeAttributes();
    }
    if (enableDarkMode) {
        darkModeAttrs = {
            'data-dark-theme': config.darkMode?.theme,
        };
    }
    if (isSection) {
        return (jsx("section", { "data-light-theme": config.lightMode?.theme, className: themeClasses, style: sectionStyle, ...darkModeAttrs, children: children }));
    }
    return (jsx(EGDSContextProvider, { config: {
            context: 'egds-local-theme-provider',
            data: {
                themeProviderLightTheme: config.lightMode?.theme,
                themeProviderDarkTheme: enableDarkMode ? config.darkMode?.theme : null,
                themeProviderClassName: themeClasses,
            },
        }, children: children }));
};

const EGDSLocalThemedBadgeSize = {
    SMALL: 'small',
    LARGE: 'large',
};
const EGDSLocalThemedBadgeLoyaltyThemes = {
    LOW: 'lowtier',
    MID: 'midtier',
    HIGH: 'hightier',
    EXTRAHIGH: 'extrahightier',
    GLOBAL_STANDARD: 'global-standardtier',
    GLOBAL_LOW: 'global-lowtier',
    GLOBAL_MIDDLE: 'global-middletier',
    GLOBAL_HIGH: 'global-hightier',
    GLOBAL_EXTRAHIGH: 'global-extrahightier',
    VIP: 'vip',
};

const getClassNameList$n = classNames.bind(styles$1);
const EGDSLocalThemedBadge = (props) => {
    const { text, size: _size, theme, children, a11yText, className } = props;
    const sharedCssClassName = 'egds-local-themed-badge-base';
    const baseCssClassName = 'egds-local-themed-badge';
    const loyaltyCssClassName = `${baseCssClassName}-loyalty`;
    const loyaltyBadgeClassNames = getClassNameList$n(sharedCssClassName, `${sharedCssClassName}-${EGDSLocalThemedBadgeSize.LARGE}`, { [`${sharedCssClassName}-has-text`]: text }, `${loyaltyCssClassName}-${validatePropType(theme, EGDSLocalThemedBadgeLoyaltyThemes) && theme}`, className);
    return (jsxs("span", { className: loyaltyBadgeClassNames, children: [children, text && (jsx("span", { className: getClassNameList$n(`${sharedCssClassName}-text`), "aria-hidden": !!a11yText, children: text })), a11yText && jsx("span", { className: getClassNameList$n('is-visually-hidden'), children: a11yText })] }));
};
EGDSLocalThemedBadge.displayName = 'EGDSLocalThemedBadge';

const getClassNameList$m = classNames.bind(styles$2);
var EGDSLocalThemedButtonSize;
(function (EGDSLocalThemedButtonSize) {
    EGDSLocalThemedButtonSize["SMALL"] = "small";
    EGDSLocalThemedButtonSize["MEDIUM"] = "medium";
    EGDSLocalThemedButtonSize["LARGE"] = "large";
})(EGDSLocalThemedButtonSize || (EGDSLocalThemedButtonSize = {}));
var EGDSLocalThemedButtonTheme;
(function (EGDSLocalThemedButtonTheme) {
    EGDSLocalThemedButtonTheme["SOLID"] = "solid-btn";
    EGDSLocalThemedButtonTheme["TRANSPARENT"] = "transparent-btn";
})(EGDSLocalThemedButtonTheme || (EGDSLocalThemedButtonTheme = {}));
class EGDSLocalThemedButton extends React.Component {
    static defaultProps = {
        isFullWidth: false,
        size: EGDSLocalThemedButtonSize.MEDIUM,
    };
    static baseClassName = 'egds-local-themed-button';
    static displayName = 'EGDSLocalThemedButton';
    render() {
        const { href } = this.props;
        const { analytics: _analytics, children, className, domRef, isFullWidth, size, tag, ...attributes } = this.props;
        const Tag = tag || (href ? 'a' : 'button');
        const newChildren = [];
        const buttonProps = {
            ...attributes,
        };
        if (Tag === 'button' && !buttonProps.type) {
            buttonProps.type = 'button';
        }
        // Enable :active css state on touch devices.
        // https://css-tricks.com/snippets/css/remove-gray-highlight-when-tapping-links-in-mobile-safari/
        if (!buttonProps.onTouchStart) {
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            buttonProps.onTouchStart = () => { };
        }
        let buttonText;
        // @ts-ignore
        React.Children.forEach(children, (child, _index) => {
            child?.props?.['data-a11ytext'] === 'true';
            buttonText = buttonText || child;
            // If (typeof child === 'string' || (typeof child?.props?.children === 'string' && !a11yText)) {
            //   buttonText = buttonText || child;
            // } else {
            //   newChildren.push(child);
            // }
        });
        // If (!buttonProps.onClickCapture && analytics) {
        //   buttonProps.onClickCapture = analyticsTracker.bind(this, analytics);
        // }
        const wrapperClassNames = getClassNameList$m(EGDSLocalThemedButton.baseClassName, {
            [`${EGDSLocalThemedButton.baseClassName}-${size}`]: validatePropType(size, EGDSLocalThemedButtonSize),
        }, {
            [`${EGDSLocalThemedButton.baseClassName}-fullWidth`]: isFullWidth,
            [`${EGDSLocalThemedButton.baseClassName}-has-text`]: buttonText,
            [`${EGDSLocalThemedButton.baseClassName}-as-link`]: href,
        }, className);
        return (jsxs(Tag, { ...buttonProps, className: wrapperClassNames, ref: domRef, children: [buttonText, newChildren] }));
    }
}

class EGDSLocalThemedPrimaryButton extends React.Component {
    static displayName = 'EGDSLocalThemedPrimaryButton';
    render() {
        const { inverse, ...props } = this.props;
        const cssClassNames = classNames(`${EGDSLocalThemedButton.baseClassName}-primary`, {
            [`${EGDSLocalThemedButton.baseClassName}-primary-inverse`]: inverse,
        }, props.className);
        return jsx(EGDSLocalThemedButton, { ...props, className: cssClassNames });
    }
}

class EGDSLocalThemedSecondaryButton extends React.Component {
    static displayName = 'EGDSLocalThemedSecondaryButton';
    render() {
        const { inverse, ...props } = this.props;
        const cssClassNames = classNames(`${EGDSLocalThemedButton.baseClassName}-secondary`, {
            [`${EGDSLocalThemedButton.baseClassName}-secondary-inverse`]: inverse,
        }, props.className);
        return (jsx(EGDSContextWrapper, { children: (context) => (jsx(EGDSLocalThemedButton, { ...props, className: cssClassNames, "data-context": context })) }));
    }
}

class EGDSLocalThemedTertiaryButton extends React.Component {
    render() {
        const { className, alignLabelToContent, inverse, ...props } = this.props;
        const cssClassNames = classNames(`${EGDSLocalThemedButton.baseClassName}-tertiary`, className, {
            [`${EGDSLocalThemedButton.baseClassName}-tertiary-align-with-content-${alignLabelToContent}`]: alignLabelToContent,
            [`${EGDSLocalThemedButton.baseClassName}-tertiary-inverse`]: inverse,
        });
        return (jsx(EGDSContextWrapper, { children: (context) => (jsx(EGDSLocalThemedButton, { ...props, className: cssClassNames, "data-context": context })) }));
    }
}
EGDSLocalThemedButton.displayName = 'EGDSLocalThemedTertiaryButton';

const EGDSLocalThemedCardContentSectionBorderMap = [
    ['top', 'block-start'],
    ['right', 'inline-end'],
    ['bottom', 'block-end'],
    ['left', 'inline-start'],
];
new Map(EGDSLocalThemedCardContentSectionBorderMap);
const EGDSLocalThemedCardContentSectionPaddingMap = [
    ['blockstart', 'block-start'],
    ['blockend', 'block-end'],
    ['inlinestart', 'inline-start'],
    ['inlineend', 'inline-end'],
];
new Map(EGDSLocalThemedCardContentSectionPaddingMap);
const EGDSLocalThemedCardTagMap = [
    ['article', 'article'],
    ['aside', 'aside'],
    ['div', 'div'],
    ['footer', 'footer'],
    ['header', 'header'],
    ['section', 'section'],
    ['ul', 'ul'],
    ['ol', 'ol'],
    ['li', 'li'],
];
const EGDSLocalThemedCardTags = new Map(EGDSLocalThemedCardTagMap);
const EGDSLocalThemedCardPlaceholderStartPhaseMap = [
    ['dark', 'dark'],
    ['light', 'light'],
];
new Map(EGDSLocalThemedCardPlaceholderStartPhaseMap);
const EGDSLocalThemedCardPlaceholderAspectRatioMap = [
    ['r1-1', 'ratio-1-1'],
    ['r1-2', 'ratio-1-2'],
    ['r1-3', 'ratio-1-3'],
    ['r1-4', 'ratio-1-4'],
    ['r1-5', 'ratio-1-5'],
    ['r1-6', 'ratio-1-6'],
];
new Map(EGDSLocalThemedCardPlaceholderAspectRatioMap);
const EGDSLocalThemedCardAspectRatioMap = [
    ['r1-1', 'ratio-1-1'],
    ['r1-2', 'ratio-1-2'],
    ['r1-3', 'ratio-1-3'],
    ['r1-4', 'ratio-1-4'],
    ['r1-5', 'ratio-1-5'],
    ['r1-6', 'ratio-1-6'],
];
new Map(EGDSLocalThemedCardAspectRatioMap);
const EGDSLocalThemedCardRoundCornersMap = [
    ['top-right', 'top-right'],
    ['top-left', 'top-left'],
    ['bottom-right', 'bottom-right'],
    ['bottom-left', 'bottom-left'],
    ['all', 'all'],
];
new Map(EGDSLocalThemedCardRoundCornersMap);
const EGDSLocalThemedCardFeaturedHeaderTitleTagMap = [
    ['h2', 'h2'],
    ['h3', 'h3'],
    ['h4', 'h4'],
    ['h5', 'h5'],
    ['h6', 'h6'],
    ['p', 'p'],
];
new Map(EGDSLocalThemedCardFeaturedHeaderTitleTagMap);
const EGDSLocalThemedCardBackgroundThemes = {
    PRIMARY: 'primary',
    SECONDARY: 'secondary',
    GLOBAL_LOYALTY_STANDARD: 'global-loyalty-standard',
    GLOBAL_LOYALTY_LOW: 'global-loyalty-low',
    GLOBAL_LOYALTY_MIDDLE: 'global-loyalty-middle',
    GLOBAL_LOYALTY_HIGH: 'global-loyalty-high',
    GLOBAL_LOYALTY_EXTRAHIGH: 'global-loyalty-extra-high',
};

const getClassNameList$l = classNames.bind(styles$3);
const EGDSLocalThemedCard = React__default.forwardRef((props, _ref) => {
    const { border, children, className, padded, placeholder: _placeholder, tag, style, ...attributes } = props;
    const newChildren = [];
    const Tag = ((tag && EGDSLocalThemedCardTags.get(tag)) ||
        EGDSLocalThemedCardTags.get('div'));
    const childrenArray = React__default.Children.toArray(children);
    // Map through the children and place the ones we want in specific places
    React__default.Children.forEach(children, (child) => {
        switch (child.type?.displayName) {
            default:
                newChildren.push(child);
        }
    });
    const baseClass = 'egds-local-themed-card';
    const backgroundClassFragment = EGDSLocalThemedCardBackgroundThemes.PRIMARY;
    const { data: contextData } = useEGDSContext();
    const { themeProviderLightTheme, themeProviderDarkTheme, themeProviderClassName } = contextData ?? {};
    const themeAttributes = {
        'data-light-theme': themeProviderLightTheme,
        'data-dark-theme': themeProviderDarkTheme,
    };
    const cssClassNames = getClassNameList$l(baseClass, `${baseClass}-roundcorner-all`, border && `${baseClass}-has-border`, padded && `${baseClass}-padded`, className, `${baseClass}-has-${backgroundClassFragment}-theme`, themeProviderClassName);
    if (childrenArray.length > 1) {
        return (jsx(Tag, { className: cssClassNames, ...attributes, style: style, ...themeAttributes, children: newChildren }));
    }
    const firstChild = childrenArray[0];
    const cardCustomStyleProps = { ...firstChild?.props?.style, ...style };
    const decoratedChild = React__default.cloneElement(firstChild, {
        className: classNames(cssClassNames, firstChild?.props?.className),
        ...themeAttributes,
        ...(Object.keys(cardCustomStyleProps).length !== 0 && { style: cardCustomStyleProps }),
    });
    return decoratedChild;
});
EGDSLocalThemedCard.displayName = 'EGDSLocalThemedCard';

const getClassNameList$k = classNames.bind(styles$4);
const EGDSLocalThemedIcon = (props) => {
    const { description, size = EGDSIconSize.MEDIUM, id, title } = props;
    return (jsx(EGDSIcon, { className: getClassNameList$k('egds-local-themed-icon'), id: id, description: description, name: "onekeycash", size: size, title: title }));
};

const getClassNameList$j = classNames.bind(styles$5);
const EGDSLocalThemedSheet = (props) => {
    const { children, isVisible, triggerRef } = props;
    const { data: contextData } = useEGDSContext();
    const { themeProviderLightTheme, themeProviderDarkTheme, themeProviderClassName } = contextData ?? {};
    const themeAttributes = {
        'data-light-theme': themeProviderLightTheme,
        'data-dark-theme': themeProviderDarkTheme,
    };
    return (jsx("div", { className: themeProviderClassName, ...themeAttributes, children: jsx(EGDSSheet, { type: "bottom", triggerRef: triggerRef, isVisible: isVisible, className: getClassNameList$j('egds-local-themed-sheet'), children: jsx(EGDSSheetContent, { children: children }) }) }));
};

/* Type size */
/** ******************* */
const EGDSLocalThemedHeadingTypeSizeMap = [
    [100, 'uitk-type-100'],
    [200, 'uitk-type-200'],
    [300, 'uitk-type-300'],
    [400, 'uitk-type-400'],
    [500, 'uitk-type-500'],
    [600, 'uitk-type-600'],
    [700, 'uitk-type-700'],
    [800, 'uitk-type-800'],
    [900, 'uitk-type-900'],
];
const EGDSLocalThemedHeadingTypeSizes = new Map(EGDSLocalThemedHeadingTypeSizeMap);
/* Type weight */
/** ******************* */
const EGDSLocalThemedHeadingTypeWeightMap = [
    ['regular', 'uitk-type-regular'],
    ['medium', 'uitk-type-medium'],
    ['bold', 'uitk-type-bold'],
];
const EGDSLocalThemedHeadingTypeWeights = new Map(EGDSLocalThemedHeadingTypeWeightMap);
/* Type alignment */
/** ******************* */
const EGDSLocalThemedHeadingTypeAlignmentMap = [
    ['left', 'uitk-type-start'],
    ['right', 'uitk-type-end'],
    ['center', 'uitk-type-center'],
];
new Map(EGDSLocalThemedHeadingTypeAlignmentMap);
/* Type overflow */
/** ******************* */
const EGDSLocalThemedHeadingTypeOverflowMap = [
    ['wrap', 'overflow-wrap'],
    ['truncate', 'truncate'],
    ['truncate-2-lines', 'truncate-lines-2'],
    ['truncate-3-lines', 'truncate-lines-3'],
    ['truncate-4-lines', 'truncate-lines-4'],
];
new Map(EGDSLocalThemedHeadingTypeOverflowMap);
/* Type hyphens */
/** ******************* */
const EGDSLocalThemedHeadingTypeHyphensMap = [
    ['none', 'hyphens-none'],
    ['manual', 'hyphens-manual'],
    ['auto', 'hyphens-auto'],
];
new Map(EGDSLocalThemedHeadingTypeHyphensMap);
/* Heading size */
/** ******************* */
const EGDSLocalThemedHeadingSizeMap = [
    [1, 'egds-local-themed-heading-1'],
    [2, 'egds-local-themed-heading-2'],
    [3, 'egds-local-themed-heading-3'],
    [4, 'egds-local-themed-heading-4'],
    [5, 'egds-local-themed-heading-5'],
    [6, 'egds-local-themed-heading-6'],
    [7, 'egds-local-themed-heading-7'],
    [8, 'egds-local-themed-heading-8'],
];
new Map(EGDSLocalThemedHeadingSizeMap);
/* Paragraph size */
/** ******************* */
const EGDSLocalThemedParagraphSizeMap = [
    [1, 'egds-local-themed-paragraph-1'],
    [2, 'egds-local-themed-paragraph-2'],
    [3, 'egds-local-themed-paragraph-3'],
];
new Map(EGDSLocalThemedParagraphSizeMap);
/* Type margin */
/** ******************* */
const EGDSLocalThemedHeadingTypeMarginMap = [
    ['half', 'egds-local-themed-text-spacing-half'],
    ['one', 'egds-local-themed-text-spacing-one'],
    ['two', 'egds-local-themed-text-spacing-two'],
    ['three', 'egds-local-themed-text-spacing-three'],
    ['four', 'egds-local-themed-text-spacing-four'],
    ['six', 'egds-local-themed-text-spacing-six'],
];
new Map(EGDSLocalThemedHeadingTypeMarginMap);
/* Heading tag */
/** ******************* */
const EGDSLocalThemedHeadingTagMap = [
    ['h1', 'h1'],
    ['h2', 'h2'],
    ['h3', 'h3'],
    ['h4', 'h4'],
    ['h5', 'h5'],
    ['h6', 'h6'],
];
const EGDSLocalThemedHeadingTags = new Map(EGDSLocalThemedHeadingTagMap);
const EGDSSubHeadingTagMap$1 = [...EGDSLocalThemedHeadingTagMap, ['p', 'p']];
new Map(EGDSSubHeadingTagMap$1);
/* Type theme */
/** ******************* */
const EGDSLocalThemedTextThemeMap = [
    ['positive', 'egds-local-themed-text-positive-theme'],
    ['negative', 'egds-local-themed-text-negative-theme'],
    ['emphasis', 'egds-local-themed-text-emphasis-theme'],
    ['default', 'egds-local-themed-text-default-theme'],
    ['loyalty', 'egds-local-themed-text-loyalty-theme'],
    ['global-loyalty', 'egds-local-themed-text-global-loyalty-theme'],
    ['inverse', 'egds-local-themed-text-inverse-theme'],
    ['light', 'egds-local-themed-text-light-theme'],
];
const EGDSLocalThemedTextThemes = new Map(EGDSLocalThemedTextThemeMap);
/* Type white space */
/** ******************* */
const EGDSLocalThemedHeadingTypeWhiteSpaceMap = [
    ['normal', 'egds-local-themed-text-white-space-normal'],
    ['nowrap', 'egds-local-themed-text-white-space-nowrap'],
    ['pre', 'egds-local-themed-text-white-space-pre'],
    ['pre-wrap', 'egds-local-themed-text-white-space-pre-wrap'],
    ['pre-line', 'egds-local-themed-text-white-space-pre-line'],
    ['break-spaces', 'egds-local-themed-text-white-space-break-spaces'],
];
new Map(EGDSLocalThemedHeadingTypeWhiteSpaceMap);
/* Text inline (phrase) tags */
/** ******************* */
const EGDSLocalThemedTextInlineTagsMap = [
    ['b', 'b'],
    ['em', 'em'],
    ['s', 's'],
    ['small', 'small'],
    ['i', 'i'],
    ['mark', 'mark'],
    ['strong', 'strong'],
    ['q', 'q'],
    ['sub', 'sub'],
    ['sup', 'sup'],
];
new Map(EGDSLocalThemedTextInlineTagsMap);

const getClassNameList$i = classNames.bind(styles$6);
/**
 * Use for freestanding text elements that are not a list, paragraph, or heading.
 * Should not replace the usage of lists or headings.
 */
const EGDSLocalThemedText = (props) => {
    const { align: _align, children, inline: _inline, size: passedInSize, spacing: _spacing, overflow: _overflow, weight, whiteSpace: _whiteSpace, className, theme = 'default', wordBreak: _wordBreak = false, dataTestId, hyphens: _hyphens, ...attributes } = props;
    const Tag = 'div';
    const size = passedInSize || 300;
    const wrapperClassNames = getClassNameList$i('egds-local-themed-text', size && EGDSLocalThemedHeadingTypeSizes.get(size), weight && EGDSLocalThemedHeadingTypeWeights.get(weight), theme && EGDSLocalThemedTextThemes.get(theme), className);
    return (
    // @ts-ignore
    jsx(Tag, { className: wrapperClassNames, ...(dataTestId ? { 'data-test-id': dataTestId } : {}), ...attributes, children: children }));
};

const getClassNameList$h = classNames.bind(styles$6);
/**
 * Use for title/headings of pages, sections, articles, listings, rate plans, etc.
 * Ensure that you are choosing the correct semantic `tag` for your heading.
 */
const EGDSLocalThemedHeading = (props) => {
    const { children, className, domRef, ...attributes } = props;
    const Tag = EGDSLocalThemedHeadingTags.get('h3');
    const wrapperClassNames = getClassNameList$h('egds-local-themed-heading', className);
    return (jsx(Tag, { className: wrapperClassNames, ref: domRef, ...attributes, children: children }));
};

const getClassNameList$g = classNames.bind(styles$6);
const EGDSLocalThemedParagraph = (props) => {
    const { size: _size, children, className, ...attributes } = props;
    const baseClassName = 'egds-local-themed-paragraph';
    const wrapperClassNames = getClassNameList$g(baseClassName, className);
    return (jsx("p", { className: wrapperClassNames, ...attributes, children: children }));
};
EGDSLocalThemedParagraph.defaultProps = {
    size: 2,
};

const getClassNameList$f = classNames.bind(styles$7);
const EGDSLocalShimmer = (props) => {
    const { animationIterations = 1, cloneElement, children } = props;
    const [pseudoElAnimationDistance, setPseudoElAnimationDistance] = React.useState(undefined);
    const [shimmerSize, setShimmerSize] = React.useState({
        inlineSize: 0,
        blockSize: 0,
    });
    let useReducedMotion = false;
    if (typeof window !== 'undefined') {
        useReducedMotion = window.matchMedia(`(prefers-reduced-motion: reduce)`).matches;
    }
    const shimmerRef = React.useRef(null);
    const baseCssClass = 'egds-local-shimmer';
    const childrenArray = React.Children.toArray(children);
    const firstChild = childrenArray[0];
    const firstChildClassName = firstChild?.props.className;
    const calculatePseudoElAnimationDistanceWithSkew = React.useCallback(() => {
        if (shimmerRef.current) {
            const skewAmount = 15;
            // Calculate triangle area created by skew effect
            const xRadians = (skewAmount * Math.PI) / 180;
            const skewCreatedTriangleWidth = shimmerSize.blockSize * Math.tan(xRadians);
            // Add this to the inline-size of the component
            const fullAnimationDistance = shimmerSize.inlineSize + skewCreatedTriangleWidth / 2;
            // Store the total in state to then consume in CSS
            setPseudoElAnimationDistance(Math.round(fullAnimationDistance));
        }
    }, [shimmerSize.inlineSize, shimmerSize.blockSize]);
    const resizeObserver = React.useMemo(() => typeof window !== 'undefined' && window.ResizeObserver
        ? new ResizeObserver((entries) => {
            for (const entry of entries) {
                if (entry.contentBoxSize) {
                    const { inlineSize, blockSize } = entry.contentBoxSize[0];
                    setShimmerSize({ inlineSize, blockSize });
                }
            }
        })
        : null, []);
    const unobserveResizeObserver = React.useCallback(() => {
        if (shimmerRef.current && resizeObserver) {
            resizeObserver.unobserve(shimmerRef.current);
        }
    }, [resizeObserver]);
    React.useLayoutEffect(() => {
        if (shimmerRef.current) {
            const { width: inlineSize, height: blockSize } = shimmerRef.current.getBoundingClientRect();
            setShimmerSize({ inlineSize, blockSize });
        }
    }, []);
    React.useEffect(() => {
        calculatePseudoElAnimationDistanceWithSkew();
        if (shimmerRef.current && resizeObserver) {
            resizeObserver.observe(shimmerRef.current);
        }
        return () => unobserveResizeObserver();
    }, []);
    React.useEffect(() => {
        calculatePseudoElAnimationDistanceWithSkew();
    }, [shimmerSize.inlineSize, shimmerSize.blockSize]);
    const cssClassNames = getClassNameList$f(baseCssClass, cloneElement && firstChildClassName, cloneElement && `${baseCssClass}-clone`);
    let decoratedChild = null;
    const cssCustomProps = {
        ...(animationIterations && {
            [`--egds-local-shimmer-animation-iteration-count`]: animationIterations,
        }),
        ...(pseudoElAnimationDistance && {
            [`--egds-local-shimmer-pseudo-el-animation-distance`]: `${pseudoElAnimationDistance}px`,
        }),
    };
    if (firstChild) {
        // If using cloneElement, typically we might clone and add to child's `style` prop values here;
        // but rather than doing this, wrapping child in empty <div> tag and adding styles (and a ref) there,
        // because some possible children components may not have `style` prop available to them to pass through to
        decoratedChild = React.cloneElement(firstChild, {
            className: cssClassNames,
        });
    }
    if (useReducedMotion || (firstChild && !cloneElement)) {
        // If children, i.e. is wrapping a child with intent to cloneElement, return children; if not, return nothing
        return jsx(Fragment, { children: children }) || jsx(Fragment, {});
    }
    return cloneElement && firstChild ? (jsx("div", { ref: shimmerRef, style: cssCustomProps, children: decoratedChild })) : (jsx("div", { ref: shimmerRef, style: cssCustomProps, className: cssClassNames }));
};
EGDSLocalShimmer.displayName = 'EGDSLocalShimmer';

const getClassNameList$e = classNames.bind(styles$8);
const EGDSTeamBlockLink = (props) => {
    const { children, target = '_self', screenReaderText, href } = props;
    const baseCssClass = 'egds-team-block-link';
    const parentClassNames = getClassNameList$e(baseCssClass);
    const linkChildClassNames = getClassNameList$e(`${baseCssClass}-link`);
    return (jsxs("div", { className: parentClassNames, children: [children, jsx("a", { href: href, className: linkChildClassNames, target: target, children: jsx("span", { className: "is-visually-hidden", children: screenReaderText }) })] }));
};
EGDSTeamBlockLink.displayName = 'EGDSTeamBlockLink';

const EGDSCardContentSectionBorderMap = [
    ['top', 'block-start'],
    ['right', 'inline-end'],
    ['bottom', 'block-end'],
    ['left', 'inline-start'],
];
const EGDSCardContentSectionBorders = new Map(EGDSCardContentSectionBorderMap);
const EGDSCardContentSectionPaddingMap = [
    ['blockstart', 'block-start'],
    ['blockend', 'block-end'],
    ['inlinestart', 'inline-start'],
    ['inlineend', 'inline-end'],
];
const EGDSCardContentSectionPaddings = new Map(EGDSCardContentSectionPaddingMap);
const EGDSCardTagMap = [
    ['article', 'article'],
    ['aside', 'aside'],
    ['div', 'div'],
    ['footer', 'footer'],
    ['header', 'header'],
    ['section', 'section'],
    ['ul', 'ul'],
    ['ol', 'ol'],
    ['li', 'li'],
];
const EGDSCardTags = new Map(EGDSCardTagMap);
const EGDSCardPlaceholderStartPhaseMap = [
    ['dark', 'dark'],
    ['light', 'light'],
];
const EGDSCardPlaceholderStartPhases = new Map(EGDSCardPlaceholderStartPhaseMap);
const EGDSCardPlaceholderAspectRatioMap = [
    ['r1-1', 'ratio-1-1'],
    ['r1-2', 'ratio-1-2'],
    ['r1-3', 'ratio-1-3'],
    ['r1-4', 'ratio-1-4'],
    ['r1-5', 'ratio-1-5'],
    ['r1-6', 'ratio-1-6'],
];
const EGDSCardPlaceholderAspectRatios = new Map(EGDSCardPlaceholderAspectRatioMap);
const EGDSCardAspectRatioMap = [
    ['r1-1', 'ratio-1-1'],
    ['r1-2', 'ratio-1-2'],
    ['r1-3', 'ratio-1-3'],
    ['r1-4', 'ratio-1-4'],
    ['r1-5', 'ratio-1-5'],
    ['r1-6', 'ratio-1-6'],
];
const EGDSCardAspectRatios = new Map(EGDSCardAspectRatioMap);
const EGDSCardRoundCornersMap = [
    ['top-right', 'top-right'],
    ['top-left', 'top-left'],
    ['bottom-right', 'bottom-right'],
    ['bottom-left', 'bottom-left'],
    ['all', 'all'],
];
const EGDSCardRoundCorners = new Map(EGDSCardRoundCornersMap);
const EGDSCardFeaturedHeaderTitleTagMap = [
    ['h2', 'h2'],
    ['h3', 'h3'],
    ['h4', 'h4'],
    ['h5', 'h5'],
    ['h6', 'h6'],
    ['p', 'p'],
];
const EGDSCardFeaturedHeaderTitleTags = new Map(EGDSCardFeaturedHeaderTitleTagMap);
const EGDSCardBackgroundThemes = {
    PRIMARY: 'primary',
    SECONDARY: 'secondary',
    HIGHLIGHT: 'highlight',
    GLOBAL_LOYALTY_STANDARD: 'global-loyalty-standard',
    GLOBAL_LOYALTY_LOW: 'global-loyalty-low',
    GLOBAL_LOYALTY_MIDDLE: 'global-loyalty-middle',
    GLOBAL_LOYALTY_HIGH: 'global-loyalty-high',
    GLOBAL_LOYALTY_EXTRAHIGH: 'global-loyalty-extra-high',
};

const getClassNameList$d = classNames.bind(styles$9);
// @ts-ignore
const EGDSTeamCardBorderRadiusIncrease = React.forwardRef((props, ref) => {
    const { backgroundTheme = EGDSCardBackgroundThemes.PRIMARY, border, children, className, containerize, placeholder, tag, ...attributes } = props;
    const Tag = ((tag && EGDSCardTags.get(tag)) || EGDSCardTags.get('div'));
    const baseClass = 'egds-team-card-border-radius-increase';
    const ratioClass = placeholder && EGDSCardAspectRatios.get(placeholder.aspectRatio);
    const isValidEGDSCardBackgroundTheme = (value) => Object.values(EGDSCardBackgroundThemes).includes(value);
    const backgroundClassFragment = backgroundTheme && isValidEGDSCardBackgroundTheme(backgroundTheme)
        ? backgroundTheme
        : EGDSCardBackgroundThemes.PRIMARY;
    const getBreakpointDrivenBorderClasses = () => {
        if (border && typeof border === 'object') {
            const breakpointDrivenStyles = Object.entries(border).map(([key, value]) => ({
                [`${baseClass}-has-border-at-${key}-${value.toString()}`]: true,
            }));
            return breakpointDrivenStyles;
        }
    };
    const cssClassNames = getClassNameList$d(baseClass, `${baseClass}-roundcorner-all`, border && typeof border === 'boolean' && `${baseClass}-has-border`, !children && `${baseClass}-empty`, className, placeholder && `${baseClass}-${ratioClass}`, `${baseClass}-has-${backgroundClassFragment}-theme`, containerize && `${baseClass}-containerized`, border && typeof border === 'object' && `${baseClass}-has-breakpoint-driven-border`, border && typeof border === 'object' && getBreakpointDrivenBorderClasses());
    return (jsx(Tag, { className: cssClassNames, ...attributes, ref: ref, children: children }));
});
EGDSTeamCardBorderRadiusIncrease.displayName = 'EGDSTeamCardBorderRadiusIncrease';

// --
// Grid types
// --
const EGDSTeamLayoutGridContainerBasedSizingColumnRows = [1, 2, 3, 4, 6, 8, 12];
const EgdsSizingLengths = [
    '0x',
    '0x__half',
    '0x__quarter',
    '1x',
    '1x__half',
    '2x',
    '3x',
    '3x__half',
    '4x',
    '4x__half',
    '5x',
    '6x',
    '7x',
    '8x',
    '9x',
    '10x',
    '11x',
    '12x',
    '13x',
    '14x',
    '15x',
    '16x',
    '17x',
    '18x',
    '24x',
    '30x',
    '37x',
    '38x',
    '40x',
    '48x',
    '70x',
    '72x',
    '76x',
    '88x',
    '96x',
    '104x',
    '112x',
    '120x',
    '180x',
    '312x',
    '500x',
];
const EGDSTeamLayoutGridContainerBasedSizingAligns = ['start', 'end', 'center', 'stretch'];
const EGDSTeamLayoutGridContainerBasedSizingPlaces = [
    'start',
    'end',
    'center',
    'stretch',
    'space-around',
    'space-between',
    'space-evenly',
];
const EGDSTeamLayoutGridContainerBasedSizingAutoFlows = [
    'row',
    'column',
    'dense',
    'row-dense',
    'column-dense',
];
/**
 * Keyword block-size (height) sizes
 *
 * @type 'full_size'
 */
const EGDSTeamLayoutGridContainerBasedSizingBlockSizes = ['full_size'];
// --
// Grid item types
// --
const EGDSTeamLayoutGridContainerBasedSizingSpans = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
const EGDSTeamLayoutGridContainerBasedSizingItemPlaceSelfs = ['start', 'end', 'center', 'stretch'];

/**
 * Check string is a valid EgdsSizingLength value
 *
 * @param size {string} - size
 * @returns EgdsSizingLengths.includes(size as EgdsSizingLength)
 */
const IsEgdsSize = (size) => EgdsSizingLengths.includes(size);
/**
 * Check string is a valid FlexibleEgdsSizingLength value
 *
 * @param length {string} - length
 * @returns FlexibleEgdsSizingLength.includes(size as EgdsSizingLength)
 */
const IsFlexibleEgdsSize = (length) => length.endsWith('px');
/**
 * Check for deprecated "auto_fit" or "auto_fill" keys
 *
 * @param obj {EGDSLayoutConditionalGridTrack} - object
 * @returns boolean
 */
const isAutoRepeatGrid = (obj) => Object.prototype.hasOwnProperty.call(obj, 'auto_fill') || Object.prototype.hasOwnProperty.call(obj, 'auto_fit');
/**
 * Check for "small" key
 *
 * This is used when checking values that can be applied per breakpoint, as "small" queries are
 * treated as regular values (ie: not encased in a media query when used in the CSS)
 *
 * @param key {string} - key
 * @returns boolean
 */
const isSmallKey = (key) => key === 'small';
/**
 * Outputs a css custom property for a valid EgdsSizingLength value
 *
 * @param value {EgdsSizingLength} - value
 * @returns `var(--uitk-layoutgrid-egds-size__${value})`
 */
const EgdsSizeCustomProp = (value) => `var(--uitk-layoutgrid-egds-size__${value})`;
/**
 * Outputs a pixel length, rounded to comply with the EGDS base-4 sizing rule as used to make
 * all [sizing tokens](https://egds.expedia.biz/latest/tokens/default#foundation-sizing)
 *
 * @param value {number} - number to convert
 * @param options {convertNumberToBase4Options} - options to manage rounding (set to EGDS defaults)
 */
const MakeEgdsSizingLength = (pxValue, options = {
    step: 4,
    exceptions: [1, 2, 6, 14, 18],
}) => {
    const UnitlessValue = Number(pxValue.replace('px', ''));
    const isException = options.exceptions.includes(UnitlessValue);
    return isException ? pxValue : `${Math.round(UnitlessValue / options.step) * options.step}px`;
};
/**
 * Returns a track item, checking if it is an EGDS size that needs to be processed
 *
 * @param item {any} - track item to return
 */
const MaketrackItem = (item) => {
    let trackItem;
    if (IsEgdsSize(item)) {
        trackItem = EgdsSizeCustomProp(item);
    }
    else if (IsFlexibleEgdsSize(item)) {
        trackItem = MakeEgdsSizingLength(item);
    }
    else {
        trackItem = item;
    }
    return trackItem;
};
/**
 * Outputs a css fit-content() function
 *
 * @param length {EgdsSizingLength | FlexibleEgdsSizingLength} - length
 * @returns {`fit-content(${typeof fitContentValue})`} `fit-content(length)`
 */
const FitContent = (length) => {
    const fitContentValue = MaketrackItem(length);
    const fitcontentValue = `fit-content(${fitContentValue})`;
    return fitcontentValue;
};
/**
 * Outputs a css minmax() function
 *
 * @param min {EGDSTeamLayoutGridContainerBasedSizingLength} - min value
 * @param max {EGDSTeamLayoutGridContainerBasedSizingLength} - max value
 * @returns {`minmax(${typeof minValue}, ${typeof maxValue})`} `minmax(min, max)`
 */
const MinMax = (min, max) => {
    const minValue = MaketrackItem(min);
    const maxValue = MaketrackItem(max);
    const minmaxValue = `minmax(${minValue}, ${maxValue})`;
    return minmaxValue;
};
/**
 * Outputs a css repeat() function
 *
 * @param repeatType {number | 'auto-fit' | 'auto-fill'} - repeat type
 * @param track {EGDSTeamLayoutGridContainerBasedSizingLength | ReturnType<typeof MinMax> | ReturnType<typeof FitContent>} - track to repeat
 * @returns {`repeat(${typeof repeatType}, ${typeof track})`} `repeat(repeatType, track)`
 */
const Repeat = (repeatType, track) => {
    const trackValue = MaketrackItem(track);
    const repeatValue = `repeat(${repeatType}, ${trackValue})`;
    return repeatValue;
};

const getClassNameList$c = classNames.bind(styles$a);
const baseClass = 'uitk-layout-grid';
/**
 * Set a valid grid track value
 *
 * @param value {any}
 * @returns string
 */
const trackList = (value) => {
    const track = [];
    const isArray = Array.isArray(value);
    const isNumber = typeof value === 'number';
    if (isArray) {
        value.forEach((item) => track.push(MaketrackItem(item)));
    }
    else if (isNumber) {
        track.push(`repeat(${value}, minmax(0, 1fr))`); // Include minmax() to ensure unbroken content doesn't force grid out
    }
    else {
        track.push(MaketrackItem(value));
    }
    return track.join(' ');
};
/**
 * Generate a valid CSS custom prop / value object for grid areas
 *
 * @param areas {EGDSTeamLayoutGridContainerBasedSizingArea | EGDSLayoutConditionalGridArea}
 * @returns Object as React.CSSProperties
 */
const areasValue = (areas) => {
    const isObject = !Array.isArray(areas) && typeof areas === 'object';
    const obj = {};
    const areaRows = (value) => value.map((area) => `"${area}"`).join(' ');
    if (isObject) {
        Object.entries(areas).map(([key, val]) => Object.assign(obj, {
            [`--uitk-layoutgrid-areas${isSmallKey(key) ? '' : `-${key}`}`]: areaRows(val),
        }));
    }
    else {
        Object.assign(obj, { [`--uitk-layoutgrid-areas`]: areaRows(areas) });
    }
    return obj;
};
/**
 * Generate a valid CSS custom prop / value object for grid gap
 *
 * @param value {EGDSLayoutSpace | EGDSTeamLayoutGridContainerBasedSizingSpaceInterface}
 * @returns Object as React.CSSProperties
 */
const spaceValue = (value) => {
    const isString = typeof value === 'string';
    const colValue = isString ? value : value.column;
    const rowValue = isString ? value : value.row;
    return {
        ...(colValue && { [`--uitk-layoutgrid-column-gap`]: `var(--uitk-layoutgrid-space-${colValue})` }),
        ...(rowValue && { [`--uitk-layoutgrid-row-gap`]: `var(--uitk-layoutgrid-space-${rowValue})` }),
    };
};
/**
 * Set a valid value for the deprecated EGDSTeamLayoutGridContainerBasedSizingAutoRepeat interface
 *
 * @param repeatType {string} Type of repeat
 * @param minValue {any} min value for the minmax() part of the repeat() function
 * @param suffix {string} suffix for the custom property name
 * @returns object as React.CSSProperties
 */
const autoRepeatGridValue = (repeatType, minValue, suffix) => {
    const newRepeatType = repeatType.replace('_', '-');
    return {
        [`--uitk-layoutgrid-${suffix}`]: `repeat(${newRepeatType}, minmax(var(--uitk-layoutgrid-egds-size__${minValue}), 1fr))`,
    };
};
/**
 * Generate a valid CSS custom prop / value object for:
 *
 * - columns
 * - rows
 * - autoColumns
 * - autoRows
 *
 * @param value {EGDSLayoutSpace | EGDSTeamLayoutGridContainerBasedSizingSpaceInterface}
 * @returns Object as React.CSSProperties
 */
const gridTrackValue = (value, suffix) => {
    const isObject = !Array.isArray(value) && typeof value === 'object';
    const obj = {};
    if (isObject) {
        Object.entries(value).map(([key, val]) => {
            if (trackList(val)) {
                Object.assign(obj, isAutoRepeatGrid(value)
                    ? autoRepeatGridValue(key, val, suffix)
                    : { [`--uitk-layoutgrid-${suffix}${isSmallKey(key) ? '' : `-${key}`}`]: trackList(val) });
            }
            return null;
        });
    }
    else if (trackList(value)) {
        Object.assign(obj, { [`--uitk-layoutgrid-${suffix}`]: trackList(value) });
    }
    return obj;
};
/**
 * Generate a valid CSS custom prop for blockSize
 *
 * @param value {EGDSTeamLayoutGridContainerBasedSizingBlockSize}
 * @param suffix {string}
 * @returns Object as React.CSSProperties
 */
const blockSizeValue = (value, suffix) => {
    const obj = {};
    let newValue;
    if (value !== 'full_size') {
        // If value is a viewport block (vb) length,
        // convert to viewport height (vh) for the time being,
        // until browser support matches our requirements
        // https://caniuse.com/mdn-css_types_length_vb
        newValue = value.replace('vb', 'vh');
        Object.assign(obj, { [`--uitk-layoutgrid-${suffix}`]: newValue });
    }
    return obj;
};
/**
 * Prevent invalid CSS Custom Properties from being applied
 *
 * @param value {EGDSTeamLayoutGridContainerBasedSizingArea | EGDSLayoutConditionalGridArea | EGDSTeamLayoutGridContainerBasedSizingTrack | EGDSLayoutConditionalGridTrack}
 * @param suffix {string}
 * @param baseCSSClass {string}
 * @returns getClassNameList()
 */
const conditionalGridTrackClassName = (value, suffix, baseCSSClass = baseClass) => {
    const isObject = !Array.isArray(value) && typeof value === 'object';
    const isautoGrid = isObject &&
        (Object.prototype.hasOwnProperty.call(value, 'auto_fill') ||
            Object.prototype.hasOwnProperty.call(value, 'auto_fit'));
    return getClassNameList$c(isObject
        ? Object.entries(value).map(([key]) => `${baseCSSClass}-has-${suffix}${isSmallKey(key) ? '' : `-by-${key}`}`)
        : `${baseCSSClass}-has-${suffix}`, isautoGrid && `${baseCSSClass}-has-${suffix}-using-auto-grid`);
};
const conditionalBlockSizeClassName = (value, suffix, baseCSSClass = baseClass) => (value === 'full_size' ? `${baseCSSClass}-${suffix}-${value}` : `${baseCSSClass}-${suffix}-explicit_size`);
const wrapperClassNames = ({ areas, alignContent, alignItems, autoFlow, autoColumns, autoRows, blockSize, className, columns, display, justifyContent, justifyItems, minBlockSize, rows, space, }) => getClassNameList$c(baseClass, alignContent && `${baseClass}-align-content-${alignContent}`, alignItems && `${baseClass}-align-items-${alignItems}`, areas && conditionalGridTrackClassName(areas, 'areas'), autoColumns && `${baseClass}-has-auto-columns`, autoRows && `${baseClass}-has-auto-rows`, columns && conditionalGridTrackClassName(columns, 'columns'), rows && conditionalGridTrackClassName(rows, 'rows'), space && `${baseClass}-has-space`, autoFlow && `${baseClass}-auto-flow-${autoFlow}`, blockSize && conditionalBlockSizeClassName(blockSize, 'block-size'), display && `${baseClass}-display-${display}`, justifyContent && `${baseClass}-justify-content-${justifyContent}`, justifyItems && `${baseClass}-justify-items-${justifyItems}`, minBlockSize && `${baseClass}-min-block-size-${minBlockSize}`, className);
const EGDSTeamLayoutGridContainerBasedSizing = (props) => {
    const { alignContent, alignItems, areas, autoColumns, autoFlow, autoRows, blockSize, children, display, space, columns, className, justifyContent, justifyItems, minBlockSize, rows, tag, dataTestId, style, ...attributes } = props;
    const wrapperClassNameProps = {
        alignContent,
        alignItems,
        autoFlow,
        autoColumns,
        autoRows,
        areas,
        blockSize,
        className,
        columns,
        display,
        justifyContent,
        justifyItems,
        minBlockSize,
        rows,
        space,
    };
    const gridCustomProps = {
        ...(areas && areasValue(areas)),
        ...(autoColumns && gridTrackValue(autoColumns, 'auto-columns')),
        ...(autoRows && gridTrackValue(autoRows, 'auto-rows')),
        ...(columns && gridTrackValue(columns, 'columns')),
        ...(rows && gridTrackValue(rows, 'rows')),
        ...(space && spaceValue(space)),
        ...(blockSize && blockSizeValue(blockSize, 'block-size')),
        ...(style && style),
    };
    // Renders the custom Tag
    const Tag = ((tag && EGDSLayoutTags.get(tag)) || EGDSLayoutTags.get('div'));
    return children ? (jsx(Tag, { className: wrapperClassNames({ ...wrapperClassNameProps }), style: gridCustomProps, ...attributes, ...(dataTestId && { 'data-test-id': dataTestId }), children: children })) : null;
};
EGDSTeamLayoutGridContainerBasedSizing.displayName = 'EGDSTeamLayoutGridContainerBasedSizing';
EGDSTeamLayoutGridContainerBasedSizing.defaultProps = {
    autoColumns: [MinMax('0x', '1fr')],
    display: 'grid',
};
const withEGDSTeamLayoutGridContainerBasedSizing = (WrappedComponent) => {
    const WithEGDSTeamLayoutGridContainerBasedSizing = (props) => {
        const { alignContent, alignItems, autoColumns, autoFlow, autoRows, areas, blockSize, className, children, columns, display, justifyContent, justifyItems, minBlockSize, rows, space, style, } = props;
        const wrapperClassNameProps = {
            alignContent,
            alignItems,
            autoFlow,
            autoColumns,
            autoRows,
            areas,
            blockSize,
            className,
            columns,
            display,
            justifyContent,
            justifyItems,
            minBlockSize,
            rows,
            space,
        };
        const gridCustomProps = {
            ...(areas && areasValue(areas)),
            ...(autoColumns && gridTrackValue(autoColumns, 'auto-columns')),
            ...(autoRows && gridTrackValue(autoRows, 'auto-rows')),
            ...(columns && gridTrackValue(columns, 'columns')),
            ...(rows && gridTrackValue(rows, 'rows')),
            ...(space && spaceValue(space)),
            ...(blockSize && blockSizeValue(blockSize, 'block-size')),
            ...(style && style),
        };
        return (jsx(WrappedComponent, { className: wrapperClassNames({ ...wrapperClassNameProps }), style: gridCustomProps, children: children || null }));
    };
    WithEGDSTeamLayoutGridContainerBasedSizing.displayName = `withEGDSTeamLayoutGridContainerBasedSizing(${WrappedComponent.displayName})`;
    return WithEGDSTeamLayoutGridContainerBasedSizing;
};

const getClassNameList$b = classNames.bind(styles$a);
const EGDSTeamLayoutGridContainerBasedSizingItem = (props) => {
    const { alignSelf, area, className, colEnd, colSpan, colStart, dataTestId, justifySelf, rowSpan, rowStart, rowEnd, style, children, } = props;
    const childrenArray = React.Children.toArray(children);
    if (!childrenArray.length) {
        return null;
    }
    const firstChild = childrenArray[0];
    const firstChildClassName = firstChild.props.className;
    const firstChildStyle = firstChild.props.style;
    const baseClass = 'uitk-layout-grid-item';
    const itemCustomPropValue = (suffix, value, isSpan) => {
        const isEnd = value === 'end';
        const isAll = value === 'all';
        let returnValue = {};
        if (isEnd) {
            returnValue = {
                [`--uitk-layoutgrid-${suffix}`]: `-1`,
            };
        }
        else if (isAll) {
            returnValue = {
                [`--uitk-layoutgrid-${suffix}`]: `1`,
                [`--uitk-layoutgrid-${suffix.replace('start', 'end')}`]: `-1`,
            };
        }
        else {
            returnValue = {
                [`--uitk-layoutgrid-${suffix}`]: isSpan ? `span ${value}` : `${value}`,
            };
        }
        return returnValue;
    };
    const MakeCustomProp = (suffix, value, isSpan) => {
        const isObject = !Array.isArray(value) && typeof value === 'object';
        const obj = {};
        if (isObject) {
            Object.entries(value).map(([key, val]) => Object.assign(obj, itemCustomPropValue(`${suffix}${isSmallKey(key) ? '' : `-${key}`}`, val, isSpan)));
        }
        else {
            Object.assign(obj, itemCustomPropValue(suffix, value, isSpan));
        }
        return obj;
    };
    /**
     * Prevent invalid CSS Custom Properties from being applied
     *
     * @param value {EGDSTeamLayoutGridContainerBasedSizingItemSpanValues | EGDSLayoutConditionalGridSpan | EGDSTeamLayoutGridContainerBasedSizingItemStartEndValues | EGDSLayoutConditionalGridStartEnd}
     * @param suffix {string}
     * @param baseCSSClass {string}
     * @returns getClassNameList()
     */
    const conditionalGridItemClassName = (value, suffix, baseCSSClass = baseClass) => {
        const isObject = !Array.isArray(value) && typeof value === 'object';
        return getClassNameList$b(isObject
            ? Object.entries(value).map(([key]) => `${baseCSSClass}-has-${suffix}${isSmallKey(key) ? '' : `-by-${key}`}`)
            : `${baseCSSClass}-has-${suffix}`);
    };
    const wrapperClassNames = getClassNameList$b(baseClass, firstChildClassName, alignSelf && `${baseClass}-align-self-${alignSelf}`, area &&
        `${baseClass}-has-column-start ${baseClass}-has-column-end ${baseClass}-has-row-start ${baseClass}-has-row-end`, colStart && conditionalGridItemClassName(colStart, 'column-start'), colEnd && conditionalGridItemClassName(colEnd, 'column-end'), colSpan && conditionalGridItemClassName(colSpan, 'column-start'), colSpan && colSpan === 'all' && conditionalGridItemClassName(colSpan, 'column-end'), rowStart && conditionalGridItemClassName(rowStart, 'row-start'), rowEnd && conditionalGridItemClassName(rowEnd, 'row-end'), rowSpan && conditionalGridItemClassName(rowSpan, 'row-start'), rowSpan && rowSpan === 'all' && conditionalGridItemClassName(rowSpan, 'row-end'), justifySelf && `${baseClass}-justify-self-${justifySelf}`, className);
    const gridItemCustomProps = {
        ...(area && {
            [`--uitk-layoutgrid-column-start`]: `${area}-start`,
            [`--uitk-layoutgrid-column-end`]: `${area}-end`,
            [`--uitk-layoutgrid-row-start`]: `${area}-start`,
            [`--uitk-layoutgrid-row-end`]: `${area}-end`,
        }),
        ...(!area && {
            ...(colSpan && MakeCustomProp('column-start', colSpan, true)),
            ...(colStart && MakeCustomProp('column-start', colStart)),
            ...(colEnd && MakeCustomProp('column-end', colEnd)),
            ...(rowSpan && MakeCustomProp('row-start', rowSpan, true)),
            ...(rowStart && MakeCustomProp('row-start', rowStart)),
            ...(rowEnd && MakeCustomProp('row-end', rowEnd)),
        }),
        ...(firstChildStyle && firstChildStyle),
        ...(style && style),
    };
    const decoratedChild = React.cloneElement(firstChild, {
        className: wrapperClassNames,
        style: gridItemCustomProps,
        ...(dataTestId && { 'data-stid': dataTestId }),
    });
    return decoratedChild;
};
EGDSTeamLayoutGridContainerBasedSizingItem.displayName = 'EGDSTeamLayoutGridContainerBasedSizingItem';

const EGDSTeamCarouselRefactorBreakPointSizeMap = [
    ['sm', 'sm'],
    ['md', 'md'],
    ['lg', 'lg'],
    ['xl', 'xl'],
];
const EGDSTeamCarouselRefactorBreakPointSizes = new Map(EGDSTeamCarouselRefactorBreakPointSizeMap);
const EGDSHeadingTagMap$1 = [
    ['h1', 'h1'],
    ['h2', 'h2'],
    ['h3', 'h3'],
    ['h4', 'h4'],
    ['h5', 'h5'],
    ['h6', 'h6'],
];
const EGDSHeadingTags$1 = new Map(EGDSHeadingTagMap$1);

const getClassNameList$a = classNames.bind(styles$b);
var EGDSTeamCarouselRefactorLocalAnalyticsIdType;
(function (EGDSTeamCarouselRefactorLocalAnalyticsIdType) {
    EGDSTeamCarouselRefactorLocalAnalyticsIdType["clickLeft"] = "clickLeft";
    EGDSTeamCarouselRefactorLocalAnalyticsIdType["clickRight"] = "clickRight";
    EGDSTeamCarouselRefactorLocalAnalyticsIdType["scrollLeft"] = "scrollLeft";
    EGDSTeamCarouselRefactorLocalAnalyticsIdType["scrollRight"] = "scrollRight";
})(EGDSTeamCarouselRefactorLocalAnalyticsIdType || (EGDSTeamCarouselRefactorLocalAnalyticsIdType = {}));
const Carousel = (props) => {
    const { analytics, buttonText, carouselHeaderLevel, carouselHeaderText, carouselHeaderVisible, carouselName, carouselRef, children, className, domRef, fullSheetVisible, hideNav, itemsVisible, itemsMaxHeight, l10n, loop, navigationIconId, onChange, onIndexChange, pageBy, pagingInset, pagingOverlay, peek = true, shouldSnapOnScroll, startIndex, stretchToFill, useContainerSizing = true, wrapItems, peekAmount, itemsGap = { sm: 16, md: 16, lg: 16, xl: 16 }, initialMarginSize, } = props;
    const [mounted, setMounted] = React.useState(false);
    const [currentIndex, setCurrentIndex] = React.useState(0);
    const [isTouch, setIsTouch] = React.useState(false);
    const [isRtl, setIsRtl] = React.useState(false);
    const [size, setSize] = React.useState('sm');
    const [itemsGapAmount, setItemsGapAmount] = React.useState(16);
    const [peekWidthAmount, setPeekWidthAmount] = React.useState(96);
    const [initialMarginSizeAmount, setInitialMarginSizeAmount] = React.useState(48);
    const [sizeInitialized, setSizeInitialized] = React.useState(false);
    const [pagingDirectionIsForward, setPagingDirectionIsForward] = React.useState(true);
    const NAVIGATE_WITH_BTN = React.useRef(false); // Scrolling using a paging button
    const AVOID_FREE_SCROLL = React.useRef(false); // Free scrolling is scrolling the carousel without using the paging buttons
    const SCROLL_WITHOUT_ANIMATION = React.useRef(false);
    const WRAPPER = React.useRef(null);
    // Interaction Timer of resize handler
    const INTERACTION_TIMER = 200;
    const SCROLL_TIMER = 350;
    const itemCount = React.Children.count(children);
    const wrapperRef = domRef ?? WRAPPER;
    const containerRef = React.useRef(null);
    const carouselListRef = React.useRef(null);
    // This can be non-nullable, since setViewportSize will always set a valid size
    const currentItemsVisible = itemsVisible[size];
    // Below Values are reffed because we want them to be maintained between renders
    const viewed = React.useRef([]);
    // Scroll distance is the distance between the start of one card and the next.
    const scrollDistance = React.useRef(0);
    // Distance from origin of the left-most item (or right-most item for RTL)
    const positionWithinCarousel = React.useRef(0);
    // We use this to know if the carousel is going forwards or backwards
    const directionOfScrollIsForward = React.useRef(true);
    // A11y related functions -- Starts
    const announceCards = () => {
        if (containerRef.current) {
            const visibleCardHeadingsElements = containerRef.current.querySelectorAll(`
          .egds-team-carousel-refactor-item:not([aria-hidden="true"]) h1:not([aria-hidden="true"]),
          .egds-team-carousel-refactor-item:not([aria-hidden="true"]) h2:not([aria-hidden="true"]),
          .egds-team-carousel-refactor-item:not([aria-hidden="true"]) h3:not([aria-hidden="true"]),
          .egds-team-carousel-refactor-item:not([aria-hidden="true"]) h4:not([aria-hidden="true"]),
          .egds-team-carousel-refactor-item:not([aria-hidden="true"]) h5:not([aria-hidden="true"]),
          .egds-team-carousel-refactor-item:not([aria-hidden="true"]) h6:not([aria-hidden="true"])
        `);
            const visibleCardHeadings = Array.from(visibleCardHeadingsElements).map((heading) => heading.innerText || heading.textContent);
            if (visibleCardHeadings.length > 0) {
                setTimeout(() => {
                    liveAnnounce(l10n.formatText('carousel.cardChange', visibleCardHeadings.join(', ')), Level.POLITE);
                }, 200);
            }
            else {
                setTimeout(() => {
                    liveAnnounce(l10n.formatText('gallerycarousel.imageChange', currentIndex + 1, itemCount, ''), Level.POLITE);
                }, 200);
            }
        }
    };
    const setTabIndex = () => {
        if (containerRef.current) {
            const carouselItems = containerRef.current.querySelectorAll('.egds-team-carousel-refactor-item');
            const carouselItemsArray = Array.from(carouselItems);
            carouselItemsArray.forEach((item) => {
                const carouselElement = item.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
                const carouselElementArray = Array.from(carouselElement);
                carouselElementArray
                    .filter((elem) => !elem.hasAttribute('aria-hidden'))
                    .forEach((elem) => elem[item.hasAttribute('aria-hidden') ? 'setAttribute' : 'removeAttribute']('tabindex', '-1'));
            });
        }
    };
    // A11y related functions -- Ends
    // Analytics functions -- Starts
    const viewItemAnalytics = () => {
        let vis = currentItemsVisible;
        if (peek) {
            vis += 1;
        }
        for (let i = 0; i < vis && currentIndex + i < React.Children.count(children); ++i) {
            if (!viewed.current[currentIndex + i]) {
                viewed.current[currentIndex + i] = true;
                if (typeof props.itemViewedCallback === 'function') {
                    props.itemViewedCallback(currentIndex + i);
                }
                analytics && analyticsTracker(analytics, `${carouselName}.Carousel.itemViewed.${currentIndex + i}`, '');
            }
        }
    };
    const scrollAnalytics = React.useCallback((scrollRight) => {
        analytics &&
            analyticsTracker(analytics, `${carouselName}.Carousel.${scrollRight
                ? EGDSTeamCarouselRefactorLocalAnalyticsIdType.scrollRight
                : EGDSTeamCarouselRefactorLocalAnalyticsIdType.scrollLeft}`, '');
    }, [analytics, carouselName]);
    // Analytics functions -- Ends
    // Carousel main functions -- Starts
    const getCurrentIndex = () => {
        if (containerRef.current) {
            const containerElement = containerRef.current;
            const { scrollLeft, scrollWidth } = containerElement;
            const carouselWidth = containerElement.getBoundingClientRect().width;
            const childWidth = scrollDistance.current;
            const distanceFromOrigin = Math.abs(scrollLeft);
            // Edge case for last item of carousel in view along with peeking last element of previous frame.
            // When scroll reaches the end of container then scrollLeft should be equal to scrollWidth - carouselWidth
            // but as subpixels are rounded to nearest integer this calc fails so added -5 to overcome it
            // Edge case only applies when there is more than one item
            const edgeCase = itemCount > 1 && distanceFromOrigin > Math.round(scrollWidth - carouselWidth - 5) ? 1 : 0;
            return Math.floor(distanceFromOrigin / childWidth) + edgeCase;
        }
        return 0;
    };
    const incrementIndexAsNeeded = (index) => {
        /* istanbul ignore else */
        if (directionOfScrollIsForward.current === true) {
            return index + 1;
        }
        return index;
    };
    const getIndexToSnapTo = (index) => {
        const maxIndex = itemCount - currentItemsVisible;
        const newIndex = incrementIndexAsNeeded(index);
        if (newIndex > maxIndex) {
            return maxIndex;
        }
        return newIndex;
    };
    const setScrollingForwardRef = (position) => {
        if (position > positionWithinCarousel.current) {
            directionOfScrollIsForward.current = true;
        }
        else {
            directionOfScrollIsForward.current = false;
        }
    };
    /* istanbul ignore next */
    const getIncrementalPosition = (time, positionToSnapTo, positionUserScrolledTo, range) => {
        // Quadratic easein-easeout function // refer to https://easings.net/#easeInOutQuad
        const curve = (x) => (x < 0.5 ? 2 * x ** 2 : 1 - (-2 * x + 2) ** 2 / 2);
        const done = time >= SCROLL_TIMER;
        const position = done ? positionToSnapTo : positionUserScrolledTo + range * curve(time / SCROLL_TIMER);
        return { done, position };
    };
    const reverseRtlValue = (value) => (isRtl ? value * -1 : value); // The scrollLeft method returns a negative value in RTL but our functions frequently expect a positive (or reverse) value
    // Scroll carousel to newPosition pixels from origin (which is the left edge for LTR and the right edge for RTL)
    const scrollCarousel = (newPosition) => {
        let startTimestamp;
        if (containerRef.current) {
            const containerElement = containerRef.current;
            const positionUserScrolledTo = reverseRtlValue(containerElement.scrollLeft);
            const range = newPosition - positionUserScrolledTo;
            // Incrementally advance the carousel using the curve value described above
            // istanbul ignore next
            const step = (timestamp) => {
                if (!startTimestamp) {
                    startTimestamp = timestamp;
                }
                const { done, position } = getIncrementalPosition(timestamp - startTimestamp, newPosition, positionUserScrolledTo, range);
                containerElement.scrollLeft = reverseRtlValue(position); // This moves the carousel
                if (!done) {
                    window.requestAnimationFrame(step);
                }
            };
            if (SCROLL_WITHOUT_ANIMATION.current) {
                // Occurs when startIndex is set
                SCROLL_WITHOUT_ANIMATION.current = false;
                containerElement.scrollLeft = reverseRtlValue(newPosition);
                setMounted(true);
            }
            else {
                window.requestAnimationFrame(step);
            }
            scrollAnalytics(range > 0);
            positionWithinCarousel.current = newPosition;
        }
    };
    const scrollCarouselWithNoSnap = () => {
        if (containerRef.current) {
            const positionUserScrolledTo = containerRef.current.scrollLeft;
            const isRightScroll = positionUserScrolledTo - positionWithinCarousel.current > 0;
            scrollAnalytics(isRightScroll);
            positionWithinCarousel.current = positionUserScrolledTo;
        }
    };
    // Adding this ignore comment to prevent this issue https://jira.expedia.biz/browse/EGDS-3032
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const onScroll = React.useCallback(debounce(INTERACTION_TIMER, () => {
        if (AVOID_FREE_SCROLL.current) {
            AVOID_FREE_SCROLL.current = false;
            return false;
        }
        if (containerRef.current) {
            const carouselElement = containerRef.current;
            const positionUserScrolledTo = reverseRtlValue(carouselElement.scrollLeft); // Distance between origin and the position the user scrolled to
            // Cancel snap to scroll if scroll difference is off by just a rounding error, or if it is a tab event
            if (Math.abs(positionUserScrolledTo - positionWithinCarousel.current) < 1 || NAVIGATE_WITH_BTN.current) {
                return;
            }
            setScrollingForwardRef(positionUserScrolledTo);
            const childWidth = scrollDistance.current;
            const snapToIndex = getIndexToSnapTo(getCurrentIndex());
            const positionToSnapTo = childWidth * snapToIndex; // Distance between origin and the new position to snap to
            const range = positionToSnapTo - positionUserScrolledTo;
            const maxScrollLeft = carouselElement.scrollWidth - carouselElement.clientWidth;
            // Because this function is attached to the onScroll property of the component and calls a function which scrolls the carousel,
            // the onScroll function will always run twice, which is why we need to prevent it from scrolling a second time.
            if (range === 0 && positionUserScrolledTo > 0 && positionUserScrolledTo < maxScrollLeft) {
                return;
            }
            if (shouldSnapOnScroll) {
                const effectivePeekWidth = peek && snapToIndex !== 0 ? (peekWidthAmount + itemsGapAmount) / 2 : 0;
                scrollCarousel(positionToSnapTo - effectivePeekWidth);
            }
            else {
                scrollCarouselWithNoSnap();
            }
            setCurrentIndex(snapToIndex);
        }
    }), [size, isRtl]);
    // Prevents tab events from activating scrolling
    const onKeyboardEvent = React.useCallback((e) => {
        if (e.key) {
            NAVIGATE_WITH_BTN.current = true;
            AVOID_FREE_SCROLL.current = false;
        }
    }, [size, isRtl]);
    React.useEffect(() => {
        document.body.addEventListener('keydown', onKeyboardEvent);
        return () => {
            document.body.removeEventListener('keydown', onKeyboardEvent);
        };
    }, [onKeyboardEvent]);
    const setScrollDistance = () => {
        if (containerRef.current) {
            const carouselWidth = containerRef.current.getBoundingClientRect().width;
            const effectivePeekWidth = peek ? itemsGapAmount + peekWidthAmount : 0;
            const initialScrollDistance = (carouselWidth - (currentItemsVisible - 1) * itemsGapAmount - effectivePeekWidth) / currentItemsVisible +
                itemsGapAmount;
            if (peek && peekAmount && initialMarginSize) {
                const adjustedScrollDistance = (unadjustedScrollAmount) => {
                    const adjustmentAmount = effectivePeekWidth / 2 / (currentIndex + currentItemsVisible);
                    const pagingCounter = currentIndex / currentItemsVisible;
                    const totalPagingCount = Math.ceil(itemCount / currentItemsVisible);
                    const accountForFinalPaging = () => {
                        if (pagingCounter === totalPagingCount - 2) {
                            return itemsGapAmount / 2;
                        }
                        return 0;
                    };
                    const accountForBackPaging = () => {
                        if (pagingCounter > 1) {
                            return effectivePeekWidth / (pagingCounter - 1) / (currentIndex + currentItemsVisible);
                        }
                        return 0;
                    };
                    return (unadjustedScrollAmount +
                        (pagingDirectionIsForward
                            ? adjustmentAmount + accountForFinalPaging()
                            : adjustmentAmount + accountForBackPaging()));
                };
                scrollDistance.current = adjustedScrollDistance(initialScrollDistance);
            }
            else {
                scrollDistance.current = initialScrollDistance;
            }
        }
    };
    const setViewportSize = () => {
        const carouselListElement = carouselListRef?.current;
        if (carouselListElement) {
            setScrollDistance();
            let carouselSize = getComputedStyle(carouselListElement).getPropertyValue('--size') ||
                'sm';
            if (carouselSize === 'xl' && !itemsVisible.xl) {
                carouselSize = 'lg'; // Backward compatibility if xl is not passed
            }
            setSize(carouselSize);
            if (carouselSize) {
                const itemGapLookup = itemsGap[carouselSize];
                const peekWidthAmountLookup = peek && peekAmount && peekAmount[carouselSize];
                const initialMarginSizeLookup = initialMarginSize && initialMarginSize[carouselSize];
                const peekWidthAccountingForMargin = peekWidthAmountLookup && initialMarginSizeLookup && peekWidthAmountLookup + initialMarginSizeLookup;
                itemGapLookup && setItemsGapAmount(itemGapLookup);
                peekWidthAccountingForMargin && setPeekWidthAmount(peekWidthAccountingForMargin);
                initialMarginSizeLookup && setInitialMarginSizeAmount(initialMarginSizeLookup);
            }
            if (!sizeInitialized)
                setSizeInitialized(true);
        }
    };
    const page = (direction) => {
        const capPageBy = pageBy > currentItemsVisible ? currentItemsVisible : pageBy;
        let index = direction === 1 ? currentIndex + Number(capPageBy) : currentIndex - Number(capPageBy);
        const limit = itemCount - currentItemsVisible;
        setPagingDirectionIsForward(direction === 1);
        if (index < 0) {
            index = loop ? itemCount - 1 : 0;
        }
        else if (index === limit) {
            index = limit;
        }
        else if (index > limit) {
            index = loop ? 0 : limit;
        }
        NAVIGATE_WITH_BTN.current = true;
        setCurrentIndex(index);
    };
    const onPrevCb = () => {
        page(-1);
    };
    const onNextCb = () => {
        page(1);
    };
    // Changes the carousel's current index
    const changeIndex = (index) => {
        // This is set to bypass scroll event callbacks
        NAVIGATE_WITH_BTN.current = true;
        let newIndex;
        const maxIndex = itemCount - currentItemsVisible;
        if (index < 0) {
            newIndex = 0;
        }
        else if (index >= maxIndex) {
            newIndex = maxIndex;
        }
        else {
            newIndex = index;
        }
        setCurrentIndex(newIndex);
    };
    const renderCarousel = () => {
        const styleObj = {};
        styleObj['--carousel-item-count'] = itemsVisible[size];
        styleObj['--carousel-item-count-sm'] = itemsVisible.sm;
        styleObj['--carousel-item-count-md'] = itemsVisible.md;
        styleObj['--carousel-item-count-lg'] = itemsVisible.lg;
        styleObj['--carousel-item-count-xl'] = itemsVisible.xl ? itemsVisible.xl : itemsVisible.lg;
        styleObj['--egds-team-carousel-refactor-peek-width-amount'] = `${peekWidthAmount}px`;
        styleObj['--egds-team-carousel-refactor-items-gap'] = `${itemsGapAmount}px`;
        styleObj['--egds-team-carousel-refactor-initial-margin-size'] = `${initialMarginSizeAmount}px`;
        const cssClassNames = getClassNameList$a('egds-team-carousel-refactor', (!peek || !(currentItemsVisible < itemCount)) && 'no-peek', !pagingInset && 'no-inset', !isTouch && 'no-touch', itemsMaxHeight && 'items-max-height', initialMarginSize && 'one-sided-peek-start', className, { [size]: !!size && typeof window !== 'undefined' });
        const navProps = {
            analytics,
            buttonText,
            carouselName,
            currentIndex,
            itemCount,
            itemsVisible,
            fullSheetVisible,
            loop,
            navigationIconId,
            onNextCb,
            onPrevCb,
            pagingOverlay,
            size,
            isRtl,
        };
        const CarouselHeaderLevel = ((carouselHeaderLevel && EGDSHeadingTags$1.get(carouselHeaderLevel)) ||
            EGDSHeadingTags$1.get('h3'));
        return (jsxs("div", { className: cssClassNames, ref: wrapperRef, "data-stid": "carousel-wrapper", children: [carouselHeaderText && (jsx(CarouselHeaderLevel, { className: getClassNameList$a({ [`is-visually-hidden`]: !carouselHeaderVisible }), children: carouselHeaderText })), jsx("div", { className: getClassNameList$a('egds-team-carousel-refactor-container'), "aria-label": carouselHeaderText, ref: containerRef, onScroll: onScroll, "data-stid": "carousel-container", style: styleObj, tabIndex: 0, children: jsx(EGDSTeamCarouselRefactorItemList, { itemsVisible: itemsVisible, size: size, currentIndex: currentIndex, l10n: l10n, peek: peek, wrapItems: wrapItems, itemCount: itemCount, itemsGap: itemsGapAmount, stretchToFill: stretchToFill, carouselListRef: carouselListRef, useContainerSizing: useContainerSizing, children: children }) }), !hideNav && jsx(EGDSTeamCarouselRefactorNav, { ...navProps })] }));
    };
    // Hooks
    React.useEffect(() => {
        mounted && announceCards();
        if (sizeInitialized)
            viewItemAnalytics();
        // Turn off free scroll and yet advance the carousel
        if (NAVIGATE_WITH_BTN.current) {
            NAVIGATE_WITH_BTN.current = false;
            AVOID_FREE_SCROLL.current = true;
            const effectivePeekWidth = peek && currentIndex !== 0 ? (peekWidthAmount + itemsGapAmount) / 2 / currentIndex : 0;
            scrollCarousel(currentIndex * (scrollDistance.current - effectivePeekWidth));
        }
        onIndexChange && onIndexChange(currentIndex);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentIndex, sizeInitialized]);
    React.useEffect(() => {
        // Initialize viewport size
        setViewportSize();
        // Ensure that scrollLeft position is reset on mount
        if (containerRef.current) {
            containerRef.current.scrollLeft = 0;
        }
        // Change carousel's index to startIndex without triggering scroll animation
        if (startIndex) {
            SCROLL_WITHOUT_ANIMATION.current = true;
            changeIndex(startIndex);
        }
        else {
            setMounted(true);
        }
        'ontouchstart' in window && setIsTouch(true);
        document.querySelector('html').getAttribute('dir') === 'rtl' && setIsRtl(true);
        // Adds empty aria-live region to page to ensure Jaws screen reader
        // announces on initial key press. Relates to https://jira.expedia.biz/browse/WCAG-8258
        liveAnnounce('');
        if (sizeInitialized)
            viewItemAnalytics();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [sizeInitialized]);
    React.useEffect(() => {
        let windowWidth = window.innerWidth;
        const debounceResizeHandler = debounce(INTERACTION_TIMER, () => {
            if (windowWidth === window.innerWidth) {
                return;
            }
            windowWidth = window.innerWidth;
            setViewportSize();
            const updatedCurrentIndexOnResize = getCurrentIndex();
            // Ensures that upon resize, the carousel will scroll to a position where the updated index slide will completely show.
            setCurrentIndex(updatedCurrentIndexOnResize);
            const effectivePeekWidth = peek && updatedCurrentIndexOnResize !== 0
                ? (peekWidthAmount + itemsGapAmount) / 2 / updatedCurrentIndexOnResize
                : 0;
            scrollCarousel(updatedCurrentIndexOnResize * (scrollDistance.current - effectivePeekWidth));
        });
        window.addEventListener('resize', debounceResizeHandler);
        setScrollDistance();
        return () => window.removeEventListener('resize', debounceResizeHandler);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [size, currentIndex]);
    React.useEffect(() => {
        onChange && onChange(containerRef);
        setTabIndex();
    });
    React.useEffect(() => {
        setScrollDistance();
    }, [pagingDirectionIsForward]);
    React.useImperativeHandle(carouselRef, () => ({
        changeIndex: (index) => changeIndex(index),
    }));
    // Carousel main functions -- Ends
    return renderCarousel();
};
const EGDSTeamCarouselRefactor = (props) => {
    const l10n = useLocalization();
    return jsx(Carousel, { l10n: l10n, ...props });
};
EGDSTeamCarouselRefactor.displayName = 'EGDSTeamCarouselRefactor';
EGDSTeamCarouselRefactor.defaultProps = {
    hideNav: false,
    itemsMaxHeight: false,
    navigationIconId: {
        next: 'next-button',
        prev: 'prev-button',
    },
    loop: false,
    pagingInset: false,
    pagingOverlay: false,
    peek: false,
    shouldSnapOnScroll: true,
    startIndex: 0,
    stretchToFill: true,
    wrapItems: true,
};

const getClassNameList$9 = classNames.bind(styles$b);
const EGDSTeamCarouselRefactorItem = (props) => {
    const { children, wrapItems, ariaHidden, ariaLabel, stretchToFill } = props;
    const itemRef = React.useRef(null);
    let baseClassName = 'egds-team-carousel-refactor-item';
    if (!stretchToFill) {
        baseClassName += ' egds-team-carousel-refactor-item-size-auto';
    }
    const toggleAriaHidden = (item) => {
        const itemClassName = wrapItems ? item.props.className : '';
        const itemProps = {
            ...(ariaHidden && { 'aria-hidden': true, tabIndex: -1 }),
            className: getClassNameList$9(itemClassName ? `${itemClassName} ${baseClassName}` : baseClassName),
            'data-stid': 'carousel-item',
            'aria-label': ariaLabel,
            ref: itemRef,
        };
        if (!wrapItems) {
            return React.cloneElement(item, itemProps);
        }
        return jsx("div", { ...itemProps, children: item });
    };
    const renderCarouselItem = () => {
        const item = children;
        return toggleAriaHidden(item);
    };
    return renderCarouselItem();
};
EGDSTeamCarouselRefactorItem.displayName = 'EGDSTeamCarouselRefactorItem';
EGDSTeamCarouselRefactorItem.defaultProps = {
    wrapItems: true,
};

const getClassNameList$8 = classNames.bind(styles$b);
const EGDSTeamCarouselRefactorItemList = (props) => {
    const { children, l10n, size, currentIndex, itemCount, itemsGap, useContainerSizing = true, ...itemProps } = props;
    const { itemsVisible, carouselListRef } = itemProps;
    const newChildren = React.Children.toArray(children);
    const baseClassName = 'egds-team-carousel-refactor-item-container';
    const getCarouselItems = () => {
        const items = newChildren;
        // @ts-ignore
        const currentItemsVisible = itemsVisible[size];
        // Determines the grouping to apply aria-hidden to.
        const startOfCurrentGroup = currentIndex;
        const startOfNextGroup = currentIndex + currentItemsVisible;
        const elements = React.Children.map(items, (elm, i) => {
            const ariaHidden = i < startOfCurrentGroup || i >= startOfNextGroup;
            const ariaLabel = l10n?.formatText('carousel.indexAndTotal', i + 1, itemCount);
            return (jsx(EGDSTeamCarouselRefactorItem, { ariaHidden: ariaHidden, ariaLabel: ariaLabel, ...itemProps, children: elm }, i));
        });
        return elements;
    };
    const cssClassNames = getClassNameList$8(baseClassName, useContainerSizing && 'use-container-sizing');
    const cssCustomProps = {
        ...(itemsGap && {
            [`--egds-local-items-gap`]: `${itemsGap}px`,
        }),
    };
    return (jsx("div", { className: cssClassNames, ref: carouselListRef, style: cssCustomProps, "data-stid": "carousel-list", children: getCarouselItems() }));
};
EGDSTeamCarouselRefactorItemList.displayName = 'EGDSTeamCarouselRefactorItemList';

const getClassNameList$7 = classNames.bind(styles$b);
const EGDSTeamCarouselRefactorNav = (props) => {
    const { analytics, buttonText, carouselName, currentIndex, itemCount, itemsVisible, fullSheetVisible, loop, navigationIconId, onNextCb, onPrevCb, pagingOverlay, size, isRtl, } = props;
    // @ts-ignore
    const currentItemsVisible = itemsVisible[size];
    const prevBtnClassNames = getClassNameList$7('egds-team-carousel-refactor-button-paging', 'egds-team-carousel-refactor-button-prev');
    const nextBtnClassNames = getClassNameList$7('egds-team-carousel-refactor-button-paging', 'egds-team-carousel-refactor-button-next');
    const nextBtnRef = React.useRef(null);
    const prevBtnRef = React.useRef(null);
    // Fixes issue on mobile devices where touch events trigger paging events multiple times
    const DEBOUNCE_TIMER = typeof window !== 'undefined' && 'ontouchstart' in window ? 50 : 0;
    const clickLeftAnalytics = analytics && {
        localAnalyticsId: `${carouselName}.Carousel.${EGDSTeamCarouselRefactorLocalAnalyticsIdType.clickLeft}`,
        ...analytics,
    };
    const clickRightAnalytics = analytics && {
        localAnalyticsId: `${carouselName}.Carousel.${EGDSTeamCarouselRefactorLocalAnalyticsIdType.clickRight}`,
        ...analytics,
    };
    const focusNavigationBtn = (ref) => {
        /* istanbul ignore else */
        if (ref && ref.current) {
            ref.current.focus();
        }
    };
    const onPrev = debounce(DEBOUNCE_TIMER, () => {
        /* istanbul ignore else */
        onPrevCb && onPrevCb();
        if (currentItemsVisible > 0 && currentIndex === 1) {
            focusNavigationBtn(prevBtnRef);
        }
    });
    const onNext = debounce(DEBOUNCE_TIMER, () => {
        /* istanbul ignore else */
        onNextCb && onNextCb();
        if (currentItemsVisible > 0 && currentIndex === itemCount - currentItemsVisible - 1) {
            focusNavigationBtn(nextBtnRef);
        }
    });
    const onKeyboardEvent = React.useCallback((e) => {
        /* istanbul ignore else */
        if (isRtl) {
            /* istanbul ignore else */
            if (e.key === 'ArrowLeft') {
                onNext();
            }
            else if (e.key === 'ArrowRight') {
                onPrev();
            }
        }
        else if (e.key === 'ArrowLeft') {
            onPrev();
        }
        else if (e.key === 'ArrowRight') {
            onNext();
        }
    }, 
    // Linter states that onNext & onPrev should be dependencies here (eslint-plugin-react-hooks/exhaustive-deps)
    [isRtl, onNext, onPrev]);
    const renderNav = () => {
        if (itemCount > currentItemsVisible) {
            const isPrevBtnDisabled = !loop && currentIndex === 0;
            const isNextBtnDisabled = !loop && currentIndex === itemCount - currentItemsVisible;
            return (jsxs("div", { className: getClassNameList$7('egds-team-carousel-refactor-controls'), children: [jsx(EGDSPagingPrevButton, { analytics: clickLeftAnalytics, className: prevBtnClassNames, iconId: navigationIconId?.prev, iconTitle: buttonText.prevButton, onClick: onPrev, domRef: prevBtnRef, "data-stid": "carousel-nav-prev", "aria-disabled": isPrevBtnDisabled, "aria-label": buttonText.prevButton, tabIndex: isPrevBtnDisabled ? -1 : 0, pagingOverlay: pagingOverlay }), jsx(EGDSPagingNextButton, { analytics: clickRightAnalytics, className: nextBtnClassNames, iconId: navigationIconId?.next, iconTitle: buttonText.nextButton, onClick: onNext, domRef: nextBtnRef, "data-stid": "carousel-nav-next", "aria-disabled": isNextBtnDisabled, "aria-label": buttonText.nextButton, tabIndex: isNextBtnDisabled ? -1 : 0, pagingOverlay: pagingOverlay })] }));
        }
        return null;
    };
    React.useEffect(() => {
        if (fullSheetVisible) {
            document.body.addEventListener('keydown', onKeyboardEvent);
            return () => {
                document.body.removeEventListener('keydown', onKeyboardEvent);
            };
        }
        // Linter states that onKeyboardEvent should be a dependency here (eslint-plugin-react-hooks/exhaustive-deps)
    }, [fullSheetVisible, onKeyboardEvent]);
    return renderNav();
};
EGDSTeamCarouselRefactorNav.displayName = 'EGDSTeamCarouselRefactorNav';

const getClassNameList$6 = classNames.bind(styles$b);
const CarouselPaginationDots = (props) => {
    const { activeIndex, changeIndex, inset, itemCount, l10n } = props;
    const containerRef = React.createRef();
    const { formatText } = l10n;
    // For now setting maximum pagination dots to 5, but this could be made a prop
    const maxDots = 5;
    const baseClassName = 'egds-team-carousel-refactor-pagination-dots';
    const isAtBeginning = (currentIndex = activeIndex) => currentIndex <= Math.floor(maxDots / 2);
    const isAtEnd = (currentIndex = activeIndex) => currentIndex >= itemCount - 1 - Math.floor(maxDots / 2);
    const calculateStartIndex = (newActiveIndex) => {
        let newStartIndex;
        if (isAtBeginning(newActiveIndex)) {
            newStartIndex = 0;
        }
        else if (isAtEnd(newActiveIndex)) {
            newStartIndex = itemCount - maxDots;
        }
        else {
            newStartIndex = activeIndex;
        }
        return newStartIndex;
    };
    const [startIndex, setStartIndex] = React.useState(calculateStartIndex);
    // Update starting index whenever active index changes
    React.useEffect(() => {
        setStartIndex(calculateStartIndex());
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [activeIndex]);
    // When updating the start index, scroll horizontally until the start index button is visible
    React.useEffect(() => {
        // Dot width * number of dots to scroll past * space between those dots
        const scrollDistance = 12 * startIndex;
        if (containerRef && containerRef.current) {
            containerRef.current.scrollLeft = scrollDistance;
        }
    }, [containerRef, startIndex]);
    const handleClick = (e) => {
        const clickedIndex = Number(e.currentTarget?.value);
        calculateStartIndex(clickedIndex);
        changeIndex && changeIndex(clickedIndex);
    };
    const renderDots = () => {
        const paginationDots = [];
        for (let index = 0; index < itemCount; index++) {
            const isFirstDot = index === startIndex;
            const isLastDot = index === startIndex + maxDots - 1;
            const shouldFocus = activeIndex === index;
            // Truncate: if first or last pagination dot AND there are more pages in that direction
            const shouldTruncate = (isFirstDot && !isAtBeginning()) || (isLastDot && !isAtEnd());
            const dotBaseClassName = `${baseClassName}-icon`;
            const dotClassNames = getClassNameList$6(dotBaseClassName, {
                [`${dotBaseClassName}-focus`]: shouldFocus,
                [`${dotBaseClassName}-truncate`]: shouldTruncate,
                [`${dotBaseClassName}-default`]: !shouldTruncate && !shouldFocus,
                [`${dotBaseClassName}-inset`]: inset,
                [`${dotBaseClassName}-offset`]: !inset,
            });
            const isOutOfView = index < startIndex || index >= startIndex + maxDots;
            paginationDots.push(jsx("button", { "aria-label": formatText('carousel.indexAndTotal', index + 1, itemCount), "aria-hidden": isOutOfView, "aria-current": index === activeIndex ? 'location' : false, tabIndex: isOutOfView ? -1 : 0, type: "button", className: getClassNameList$6(`${baseClassName}-button`), onClick: (e) => handleClick(e), value: index, children: jsx("div", { className: getClassNameList$6(dotClassNames), "aria-hidden": "true" }) }, index));
        }
        return paginationDots;
    };
    return (jsx("div", { ref: containerRef, className: getClassNameList$6(`${baseClassName}-container`), children: renderDots() }));
};
const EGDSTeamCarouselRefactorPaginationDots = (props) => {
    const l10n = useLocalization();
    return jsx(CarouselPaginationDots, { l10n: l10n, ...props });
};
EGDSTeamCarouselRefactorPaginationDots.displayName = 'EGDSTeamCarouselRefactorPaginationDots';

// Image Fit Types
const EGDSImageFitMap = [
    ['cover', 'fit-cover'],
    ['contain', 'fit-contain'],
];
const EGDSImageFits = new Map(EGDSImageFitMap);
// Roundcorner Types
const EGDSRoundcornerPropMap = [
    ['all', 'all'],
    ['max', 'max'],
    ['startstart', 'startstart'],
    ['startend', 'startend'],
    ['endstart', 'endstart'],
    ['endend', 'endend'],
];
const EGDSRoundcorners = new Map(EGDSRoundcornerPropMap);

const getClassNameList$5 = classNames.bind(styles$c);
var EGDSFigureAspectRatioType;
(function (EGDSFigureAspectRatioType) {
    EGDSFigureAspectRatioType["R1_1"] = "ratio-1-1";
    EGDSFigureAspectRatioType["R4_3"] = "ratio-4-3";
    EGDSFigureAspectRatioType["R3_2"] = "ratio-3-2";
    EGDSFigureAspectRatioType["R16_9"] = "ratio-16-9";
    EGDSFigureAspectRatioType["R21_9"] = "ratio-21-9";
    EGDSFigureAspectRatioType["R3_4"] = "ratio-3-4";
    EGDSFigureAspectRatioType["R4_1"] = "ratio-4-1";
})(EGDSFigureAspectRatioType || (EGDSFigureAspectRatioType = {}));
class EGDSTeamFigureRefactor extends React.Component {
    static displayName = 'EGDSTeamFigureRefactor';
    static AspectRatio = EGDSFigureAspectRatioType;
    render() {
        const { children, className, ratio, src, roundcorner, imageFit, imageFitPositionX = 'center', imageFitPositionY = 'center', additionalProps, style, } = this.props;
        const Tag = src ? 'div' : 'figure';
        const handleRoundcornerClassArray = (classArr, propArr, baseClass) => {
            propArr.forEach((arrayValue) => classArr.push(`${baseClass}-${EGDSRoundcorners.get(arrayValue)}`));
        };
        const roundcornerClass = (prop) => {
            const roundcornerBaseClass = 'egds-team-image-refactor-roundcorner';
            const propType = typeof prop;
            const classArr = [];
            const propIsArray = Array.isArray(prop);
            if (propType === 'boolean') {
                // Prop type is boolean
                classArr.push(`${roundcornerBaseClass}-all`);
            }
            else if (propIsArray) {
                // Prop type is array
                handleRoundcornerClassArray(classArr, prop, roundcornerBaseClass);
            }
            else {
                // Prop type is object
                const object = prop;
                Object.getOwnPropertyNames(object).forEach((breakpointKey) => {
                    const breakRoundcornerBaseClass = `${roundcornerBaseClass}-${breakpointKey}`;
                    if (Array.isArray(object[breakpointKey])) {
                        handleRoundcornerClassArray(classArr, object[breakpointKey], breakRoundcornerBaseClass);
                    }
                    else {
                        // EGDSRoundcornerBreakSetting type
                        const cornerObject = object[breakpointKey];
                        Object.getOwnPropertyNames(cornerObject).forEach((cornerKey) => {
                            if (cornerObject[cornerKey] === 'set') {
                                classArr.push(`${breakRoundcornerBaseClass}-${EGDSRoundcorners.get(cornerKey)}`);
                            }
                            else if (cornerObject[cornerKey] === 'unset')
                                classArr.push(`${breakRoundcornerBaseClass}-${EGDSRoundcorners.get(cornerKey)}-unset`);
                        });
                    }
                });
            }
            return classArr;
        };
        const classList = getClassNameList$5('egds-team-image-refactor', className, roundcorner && roundcornerClass(roundcorner), imageFit && `egds-team-image-refactor-${EGDSImageFits.get(imageFit)}`, {
            [`egds-team-image-refactor-${ratio} egds-team-image-refactor-ratio`]: validatePropType(ratio, EGDSFigureAspectRatioType),
            [`egds-team-image-refactor-ratio-2-1 egds-team-image-refactor-ratio`]: !ratio || ratio !== 'none',
            [`egds-team-image-refactor-imagefit-position`]: imageFit,
            'egds-team-image-refactor-background': src,
        });
        let cssStyle = {};
        if (style) {
            cssStyle = style;
        }
        else if (src) {
            cssStyle = { backgroundImage: `url("${src}")` };
        }
        else {
            cssStyle = {
                ...(imageFit && {
                    '--egds-team-image-refactor-imagefit-position-x': `${imageFitPositionX}`,
                }),
                ...(imageFit && {
                    '--egds-team-image-refactor-imagefit-position-y': `${imageFitPositionY}`,
                }),
            };
        }
        const newProps = {
            className: classList,
            style: cssStyle,
            ...additionalProps,
        };
        return jsx(Tag, { ...newProps, children: children });
    }
}

const getClassNameList$4 = classNames.bind(styles$c);
class EGDSTeamImageRefactor extends React.Component {
    static displayName = 'EGDSImage';
    static defaultProps = {
        blankDefault: false,
        customBlankBackgroundColor: false,
        src: '',
    };
    placeholderRef = React.createRef();
    constructor(props) {
        super(props);
        this.state = {
            hideImage: false,
            hidePlaceholderImage: false,
            breakpointSizesFromCSS: {
                sm: '',
                md: '',
                lg: '',
            },
        };
        this.handleError = this.handleError.bind(this);
        this.handleSuccess = this.handleSuccess.bind(this);
    }
    componentDidMount() {
        // Retrieve breakpoints from CSS so that they are tied to EGDS tokens
        const placeholderElement = this.placeholderRef.current;
        if (placeholderElement) {
            const placeholderElementStyles = window.getComputedStyle(placeholderElement);
            const receivedBreakpointSizesFromCSS = {
                sm: placeholderElementStyles.getPropertyValue('--sm-breakpoint'),
                md: placeholderElementStyles.getPropertyValue('--md-breakpoint'),
                lg: placeholderElementStyles.getPropertyValue('--lg-breakpoint'),
            };
            this.setState({
                breakpointSizesFromCSS: receivedBreakpointSizesFromCSS,
            });
        }
    }
    shouldComponentUpdate(nextProps) {
        const { hideImage } = this.state;
        if (nextProps.src && hideImage === true) {
            // This manually triggers an update and then forces a false to prevent a loop
            this.setState({
                hideImage: false,
            });
            return false;
        }
        return true;
    }
    handleError(event) {
        const { blankDefault, placeholderImage, additionalProps } = this.props;
        this.setState({
            hideImage: !!placeholderImage || !!blankDefault,
        });
        if (additionalProps) {
            // To get around TypeScript error "Property does not exist on type object"
            const castedProps = additionalProps;
            if (castedProps.onError && typeof castedProps.onError === 'function') {
                castedProps.onError(event);
            }
        }
    }
    handleSuccess(event) {
        const { additionalProps } = this.props;
        // @ts-ignore
        if (!additionalProps?.['data-lazy']) {
            this.setState({
                hidePlaceholderImage: true,
            });
        }
        if (additionalProps) {
            // To get around TypeScript error "Property does not exist on type object"
            const castedProps = additionalProps;
            if (castedProps.onLoad && typeof castedProps.onLoad === 'function') {
                castedProps.onLoad(event);
            }
        }
    }
    render() {
        const { blankDefault, className, placeholderImage, alt, src, imgRef, lazyLoading, customBlankBackgroundColor, additionalProps, additionalSources, } = this.props;
        const { hideImage, hidePlaceholderImage } = this.state;
        const imageClasses = getClassNameList$4('egds-team-image-refactor-media', className);
        const placeholderClass = getClassNameList$4('egds-team-image-refactor-placeholder', {
            [`egds-team-image-refactor-placeholder-image`]: placeholderImage && !blankDefault && !hidePlaceholderImage,
            [`egds-team-image-refactor-has-custom-background-color`]: blankDefault && customBlankBackgroundColor,
        });
        const lowerCaseAttributes = Object.fromEntries(Object.entries(additionalProps || {}).map(([key, value]) => [key.toLowerCase(), value]));
        const imageProps = {
            className: imageClasses,
            ref: imgRef,
            src,
            ...lowerCaseAttributes,
        };
        const customProps = {
            ...(customBlankBackgroundColor && {
                '--egds-team-image-refactor-custom-blank-background-color': `${customBlankBackgroundColor}`,
            }),
        };
        const makeSourceTags = () => {
            if (additionalSources) {
                const sourceTagsArray = Object.entries(additionalSources)
                    .filter(([_, value]) => value.length)
                    .map(([key, value]) => {
                    const { breakpointSizesFromCSS } = this.state;
                    const breakpointInfo = breakpointSizesFromCSS[key];
                    return (jsx("source", { srcSet: `${value}`, media: `(max-width: ${breakpointInfo})` }, `uitk-image-source-${key}`));
                });
                return sourceTagsArray;
            }
            return null;
        };
        const Tag = additionalSources ? 'picture' : 'div';
        return (jsxs(Tag, { className: placeholderClass, style: customProps, ref: this.placeholderRef, children: [additionalSources && makeSourceTags(), !hideImage && (jsx("img", { alt: alt, ...imageProps, onError: this.handleError, onLoad: this.handleSuccess, loading: lazyLoading === 'off' ? undefined : lazyLoading }))] }));
    }
}

const EGDSTeamScrimRefactorType = {
    OVERLAY: 'overlay',
    BOTTOM: 'fade-bottom',
    CUSTOM_FADE_BOTTOM: 'custom-fade-bottom',
    CUSTOM_LEADING: 'custom-leading',
    CUSTOM_OVERLAY: 'custom-overlay',
    LEADING: 'fade-leading',
    TRAILING: 'fade-trailing',
    BUTTON: 'fade-button',
    EMPTY: 'empty',
};
const EGDSTeamScrimRefactorColorType = {
    PRIMARY: 'primary-background',
    SECONDARY: 'secondary-background',
};

const getClassNameList$3 = classNames.bind(styles$d);
class EGDSTeamScrimRefactor extends React.PureComponent {
    static displayName = 'EGDSTeamScrimRefactor';
    static defaultProps = {
        type: EGDSTeamScrimRefactorType.BOTTOM,
    };
    render() {
        const { tag, type, typeAtBreakpoint, children, className, color, customColor } = this.props;
        let Tag = '';
        const isBottomScrim = type === EGDSTeamScrimRefactorType.BOTTOM;
        const isOverlayScrim = type === EGDSTeamScrimRefactorType.OVERLAY;
        const isCustomScrim = type === EGDSTeamScrimRefactorType.CUSTOM_FADE_BOTTOM || type === EGDSTeamScrimRefactorType.CUSTOM_OVERLAY;
        if (tag && tag !== '') {
            Tag = tag;
        }
        else {
            Tag = 'div';
        }
        const getBreakpointDrivenScrimClass = () => {
            if (typeAtBreakpoint) {
                const breakpointDrivenStyles = Object.entries(typeAtBreakpoint).map(([key, value]) => ({
                    [`${value}-${key}`]: validatePropType(value, EGDSTeamScrimRefactorType),
                }));
                return breakpointDrivenStyles;
            }
        };
        const wrapperClassNames = getClassNameList$3('egds-team-scrim-refactor', className, {
            [`${type}`]: validatePropType(type, EGDSTeamScrimRefactorType),
        }, {
            [`${color}`]: validatePropType(color, EGDSTeamScrimRefactorColorType),
        }, {
            [`breakpoint-driven`]: typeAtBreakpoint && Object.values(typeAtBreakpoint).length > 0,
        }, typeAtBreakpoint && getBreakpointDrivenScrimClass());
        const contextData = {
            bottomScrimContext: isBottomScrim,
            overlayScrimContext: isOverlayScrim,
            customScrimContext: isCustomScrim,
        };
        const cssCustomProps = {
            ...(customColor && {
                [`--egds-team-custom-gradient-hue`]: `${customColor.h}`,
                [`--egds-team-custom-gradient-saturation`]: `${customColor.s}%`,
                [`--egds-team-custom-gradient-lightness`]: `${customColor.l}%`,
            }),
        };
        return (jsx(Tag, { className: wrapperClassNames, style: cssCustomProps, children: jsx(EGDSContextProvider, { config: { context: 'egds-team-scrim-refactor-context', data: contextData }, children: children }) }));
    }
}

/* Type size */
/** ******************* */
const EGDSTypeSizeMap = [
    [100, 'uitk-type-100'],
    [200, 'uitk-type-200'],
    [300, 'uitk-type-300'],
    [400, 'uitk-type-400'],
    [500, 'uitk-type-500'],
    [600, 'uitk-type-600'],
    [700, 'uitk-type-700'],
    [800, 'uitk-type-800'],
    [900, 'uitk-type-900'],
];
new Map(EGDSTypeSizeMap);
/* Type weight */
/** ******************* */
const EGDSTypeWeightMap = [
    ['regular', 'uitk-type-regular'],
    ['medium', 'uitk-type-medium'],
    ['bold', 'uitk-type-bold'],
];
new Map(EGDSTypeWeightMap);
/* Type alignment */
/** ******************* */
const EGDSTypeAlignmentMap = [
    ['left', 'uitk-type-start'],
    ['right', 'uitk-type-end'],
    ['center', 'uitk-type-center'],
];
const EGDSTypeAlignments = new Map(EGDSTypeAlignmentMap);
/* Type overflow */
/** ******************* */
const EGDSTypeOverflowMap = [
    ['wrap', 'overflow-wrap'],
    ['truncate', 'truncate'],
    ['truncate-2-lines', 'truncate-lines-2'],
    ['truncate-3-lines', 'truncate-lines-3'],
    ['truncate-4-lines', 'truncate-lines-4'],
];
const EGDSTypeOverflows = new Map(EGDSTypeOverflowMap);
/* Type hyphens */
/** ******************* */
const EGDSTypeHyphensMap = [
    ['none', 'hyphens-none'],
    ['manual', 'hyphens-manual'],
    ['auto', 'hyphens-auto'],
];
const EGDSTypeHyphens = new Map(EGDSTypeHyphensMap);
/* Heading size */
/** ******************* */
const EGDSHeadingSizeMap = [
    [1, 'uitk-heading-1'],
    [2, 'uitk-heading-2'],
    [3, 'uitk-heading-3'],
    [4, 'uitk-heading-4'],
    [5, 'uitk-heading-5'],
    [6, 'uitk-heading-6'],
    [7, 'uitk-heading-7'],
    [8, 'uitk-heading-8'],
];
const EGDSHeadingSizes = new Map(EGDSHeadingSizeMap);
/* Paragraph size */
/** ******************* */
const EGDSParagraphSizeMap = [
    [1, 'uitk-paragraph-1'],
    [2, 'uitk-paragraph-2'],
    [3, 'uitk-paragraph-3'],
];
new Map(EGDSParagraphSizeMap);
/* Type margin */
/** ******************* */
const EGDSTypeMarginMap = [
    ['half', 'uitk-text-spacing-half'],
    ['one', 'uitk-text-spacing-one'],
    ['two', 'uitk-text-spacing-two'],
    ['three', 'uitk-text-spacing-three'],
    ['four', 'uitk-text-spacing-four'],
    ['six', 'uitk-text-spacing-six'],
];
new Map(EGDSTypeMarginMap);
/* Heading tag */
/** ******************* */
const EGDSHeadingTagMap = [
    ['h1', 'h1'],
    ['h2', 'h2'],
    ['h3', 'h3'],
    ['h4', 'h4'],
    ['h5', 'h5'],
    ['h6', 'h6'],
];
const EGDSHeadingTags = new Map(EGDSHeadingTagMap);
const EGDSSubHeadingTagMap = [...EGDSHeadingTagMap, ['p', 'p']];
const EGDSSubHeadingTags = new Map(EGDSSubHeadingTagMap);
/* Type theme */
/** ******************* */
const EGDSTextThemeMap = [
    ['positive', 'uitk-text-positive-theme'],
    ['negative', 'uitk-text-negative-theme'],
    ['emphasis', 'uitk-text-emphasis-theme'],
    ['default', 'uitk-text-default-theme'],
    ['loyalty', 'uitk-text-loyalty-theme'],
    ['global-loyalty', 'uitk-text-global-loyalty-theme'],
    ['inverse', 'uitk-text-inverse-theme'],
    ['light', 'uitk-text-light-theme'],
];
new Map(EGDSTextThemeMap);
/* Type white space */
/** ******************* */
const EGDSTypeWhiteSpaceMap = [
    ['normal', 'uitk-text-white-space-normal'],
    ['nowrap', 'uitk-text-white-space-nowrap'],
    ['pre', 'uitk-text-white-space-pre'],
    ['pre-wrap', 'uitk-text-white-space-pre-wrap'],
    ['pre-line', 'uitk-text-white-space-pre-line'],
    ['break-spaces', 'uitk-text-white-space-break-spaces'],
];
new Map(EGDSTypeWhiteSpaceMap);
/* Text inline (phrase) tags */
/** ******************* */
const EGDSTextInlineTagsMap = [
    ['b', 'b'],
    ['em', 'em'],
    ['s', 's'],
    ['small', 'small'],
    ['i', 'i'],
    ['mark', 'mark'],
    ['strong', 'strong'],
    ['q', 'q'],
    ['sub', 'sub'],
    ['sup', 'sup'],
];
new Map(EGDSTextInlineTagsMap);
const EGDSDisplayStyleMap = [
    ['Display Medium', 'display-medium'],
    ['Display Small', 'display-small'],
];
new Map(EGDSDisplayStyleMap);
const EGDSHeadlineStyleMap = [
    ['Headline Extra Large', 'headline-extra-large'],
    ['Headline Large', 'headline-large'],
    ['Headline Medium', 'headline-medium'],
    ['Headline Small', 'headline-small'],
    ['Headline Overline', 'headline-overline'],
];
new Map(EGDSHeadlineStyleMap);

const getClassNameList$2 = classNames.bind(styles$e);
/**
 * Use for title/headings of pages, sections, articles, listings, rate plans, etc.
 * Ensure that you are choosing the correct semantic `tag` for your heading.
 */
const EGDSTeamHeadingBreakpointSizing = (props) => {
    const { align, children, className, tag, size, overflow, hyphens, domRef, typeStyle, ...attributes } = props;
    const Tag = ((tag && EGDSHeadingTags.get(tag)) || EGDSHeadingTags.get('h3'));
    const { data: contextData } = useEGDSContext();
    const { customScrimContext, bottomScrimContext, overlayScrimContext, contextClassNames } = contextData ?? {};
    const getBreakpointDrivenTextSizeClass = () => {
        if (size && typeof size === 'object') {
            const breakpointDrivenStyles = Object.entries(size).map(([key, value]) => ({
                [`egds-team-heading-breakpoint-sizing-at-${key}-heading-${value}`]: true,
            }));
            return breakpointDrivenStyles;
        }
    };
    const wrapperClassNames = getClassNameList$2('egds-team-heading-breakpoint-sizing', align && EGDSTypeAlignments.get(align), !bottomScrimContext &&
        typeof size !== 'object' &&
        ((size && EGDSHeadingSizes.get(size)) || EGDSHeadingSizes.get(6)), overflow && EGDSTypeOverflows.get(overflow), hyphens && EGDSTypeHyphens.get(hyphens), bottomScrimContext && `in-bottom-scrim`, overlayScrimContext && `in-overlay-scrim`, customScrimContext && `in-custom-scrim`, contextClassNames?.EGDSHeading, size && typeof size === 'object' && `breakpoint-driven`, size && typeof size === 'object' && getBreakpointDrivenTextSizeClass(), className, typeStyle && `uitk-type-style-${typeStyle.customStyle}`);
    return children ? (jsx(Tag, { className: wrapperClassNames, ref: domRef, ...(typeStyle && { 'type-style-theme': typeStyle.customTheme || 'standard' }), ...attributes, children: children })) : null;
};
EGDSTeamHeadingBreakpointSizing.displayName = 'EGDSTeamHeadingBreakpointSizing';

const getClassNameList$1 = classNames.bind(styles$e);
/**
 * Use only for subheadings, which immediately follow a heading.
 * Should not be used standalone or inline with other content.
 */
const EGDSTeamSubheadingBreakpointSizing = (props) => {
    const { align, className, children, tag, overflow, hyphens, ...attributes } = props;
    const defaultTag = 'p';
    const Tag = (tag && EGDSSubHeadingTags.get(tag)) || defaultTag;
    const { data: contextData } = useEGDSContext();
    const { customScrimContext, bottomScrimContext, overlayScrimContext, contextClassNames } = contextData ?? {};
    const wrapperClassNames = getClassNameList$1('egds-team-subheading-breakpoint-sizing', align && EGDSTypeAlignments.get(align), overflow && EGDSTypeOverflows.get(overflow), hyphens && EGDSTypeHyphens.get(hyphens), bottomScrimContext && `in-bottom-scrim`, overlayScrimContext && `in-overlay-scrim`, customScrimContext && `in-custom-scrim`, contextClassNames?.EGDSSubheading, className);
    return children ? (jsx(Tag, { className: wrapperClassNames, ...attributes, children: children })) : null;
};

const EGDSTeamLottieAnimationEventTypes = {
    ERROR: 'error',
    LOAD: 'load',
    LOOP: 'loop',
};

const getClassNameList = classNames.bind(styles$f);
const EGDSTeamAnimatedMark = (props) => {
    const [numberOfLoopsComplete, setNumberOfLoopsComplete] = React.useState(1);
    const [inAnimationErrorMode, setInAnimationErrorMode] = React.useState(false);
    const [inFallbackImgLoadErrorMode, setInFallbackImgLoadErrorMode] = React.useState(false);
    const [prefersReducedMotion, setPrefersReducedMotion] = React.useState(true); // Set this to true, then toggle once rendered with window available, using useEffect();
    const lottiePlayerRef = React.useRef(null);
    const { src, id, sizingOrientation = 'landscape', className, size = 152, animationIterations = 1, endOnLastFrame = true, playAnimation = true, description, fallbackImgUrl, } = props;
    const handleAnimationEvents = (e) => {
        const stopOnFrame = () => {
            if (endOnLastFrame) {
                const numberOfFrames = lottiePlayerRef?.current?.state?.instance?.totalFrames;
                numberOfFrames && lottiePlayerRef?.current?.setSeeker(numberOfFrames);
            }
            else {
                lottiePlayerRef?.current?.stop();
            }
        };
        if (e === EGDSTeamLottieAnimationEventTypes.ERROR) {
            setInAnimationErrorMode(true);
        }
        if (e === EGDSTeamLottieAnimationEventTypes.LOAD) {
            prefersReducedMotion && stopOnFrame();
        }
        if (e === EGDSTeamLottieAnimationEventTypes.LOOP && animationIterations !== 'infinite') {
            setNumberOfLoopsComplete(numberOfLoopsComplete + 1);
            if (numberOfLoopsComplete === animationIterations) {
                stopOnFrame();
            }
        }
    };
    const baseCssClass = getClassNameList('egds-team-animated-mark');
    const cssClassNames = getClassNameList(baseCssClass, className, {
        [`${baseCssClass}-${sizingOrientation}-oriented`]: sizingOrientation,
    });
    const wrapperClassNames = getClassNameList(`${baseCssClass}-wrapper`, {
        [`${baseCssClass}-wrapper-with-fallback-image-error`]: inFallbackImgLoadErrorMode,
        [`${baseCssClass}-wrapper-${sizingOrientation}-oriented`]: inFallbackImgLoadErrorMode && sizingOrientation,
    });
    const markCustomProps = {
        [`--egds-team-animated-mark-base4-size`]: `${MakeEgdsSizingLength$1(size)}`,
    };
    React.useEffect(() => {
        const prefersReducedMotionIsSet = typeof window !== 'undefined' && window.matchMedia(`(prefers-reduced-motion: reduce)`).matches;
        setPrefersReducedMotion(prefersReducedMotionIsSet);
    }, [prefersReducedMotion]);
    React.useEffect(() => {
        if (!prefersReducedMotion && playAnimation) {
            lottiePlayerRef?.current?.play();
        }
        else {
            lottiePlayerRef?.current?.stop();
        }
    }, [prefersReducedMotion, playAnimation]);
    return (jsx(Fragment, { children: inAnimationErrorMode && !inFallbackImgLoadErrorMode ? (jsx("img", { alt: description, onError: () => setInFallbackImgLoadErrorMode(true), className: cssClassNames, src: fallbackImgUrl, style: markCustomProps, id: id })) : (jsx("div", { role: "img", "aria-label": description, className: wrapperClassNames, style: markCustomProps, children: !inFallbackImgLoadErrorMode && (jsx(Player, { id: id, className: cssClassNames, ref: lottiePlayerRef, onEvent: handleAnimationEvents, autoplay: playAnimation, loop: (typeof animationIterations === 'number' && animationIterations > 1) ||
                    animationIterations === 'infinite', keepLastFrame: endOnLastFrame, src: src })) })) }));
};
EGDSTeamAnimatedMark.displayName = 'EGDSTeamAnimatedMark';

const EGDSTeamPatternFeatureCarousel = (props) => {
    const { buttonAnalytics, buttonDomRef, buttonOnClick, carouselTitle, carouselName, carouselClassName, carouselAnalytics, carouselNextButtonText = 'Show next items', carouselPrevButtonText = 'Show previous items', children, patternImgSrcMedLarge, patternImgSrcSmall, patternImgAltText, scrimCustomColor = { h: 231, s: 40, l: 16 }, patternButtonLink, patternButtonText = 'See all', } = props;
    const carouselProps = {
        analytics: carouselAnalytics,
        carouselName,
        className: carouselClassName,
        itemsMaxHeight: false,
        itemsVisible: {
            sm: 1,
            md: 3,
            lg: 4,
        },
        pagingInset: true,
        pageBy: 4,
        peek: true,
        wrapItems: true,
        navigationIconId: {
            next: 'next-button',
            prev: 'prev-button',
        },
        buttonText: {
            nextButton: carouselNextButtonText,
            prevButton: carouselPrevButtonText,
        },
        shouldSnapOnScroll: false,
        useContainerSizing: false,
        initialMarginSize: { sm: 24, md: 32, lg: 48 },
        peekAmount: { sm: 48, md: 16, lg: 32 },
        itemsGap: { sm: 16, md: 16, lg: 16 },
    };
    const smallBreakpointSpacing = 'six';
    const medBreakpointSpacing = 'eight';
    const largeBreakpointSpacing = 'twelve';
    const getPrimaryButton = () => (jsx(EGDSPrimaryButton, { tag: "a", onClick: buttonOnClick, domRef: buttonDomRef, analytics: buttonAnalytics, href: patternButtonLink, size: EGDSButtonSize.SMALL, inverse: true, children: patternButtonText }));
    return (jsx(EGDSTeamCardBorderRadiusIncrease, { containerize: true, tag: "section", children: jsxs(EGDSTeamLayoutGridContainerBasedSizing, { columns: 1, className: "egds-team-layout-grid-container-based-sizing-has-top-spacer", rows: {
                small: [],
                medium: [],
            }, children: [jsx(EGDSTeamLayoutGridContainerBasedSizingItem, { colSpan: "all", rowSpan: "all", children: jsx("div", { children: jsx(EGDSTeamFigureRefactor, { imageFit: "cover", ratio: "none", imageFitPositionY: "top", children: jsx(EGDSTeamImageRefactor, { blankDefault: true, src: patternImgSrcMedLarge, alt: patternImgAltText, additionalSources: { sm: patternImgSrcSmall }, customBlankBackgroundColor: `hsl(${scrimCustomColor.h}, ${scrimCustomColor.s}%, ${scrimCustomColor.l}%)` }) }) }) }), jsx(EGDSTeamLayoutGridContainerBasedSizingItem, { colSpan: "all", rowStart: 2, rowEnd: 3, children: jsx(EGDSLayoutPosition, { type: "relative", children: jsxs(EGDSTeamLayoutGridContainerBasedSizing, { columns: 3, rows: ['min-content', 'min-content'], children: [jsx(EGDSTeamLayoutGridContainerBasedSizingItem, { colSpan: "all", rowStart: 1, rowEnd: 2, children: jsx(EGDSLayoutPosition, { type: "relative", position: { zindex: 'layer2' }, children: jsx(EGDSTeamScrimRefactor, { type: "custom-fade-bottom", customColor: scrimCustomColor, children: jsx(EGDSSpacing, { padding: {
                                                    blockstart: 'twelve',
                                                    small: { inline: smallBreakpointSpacing },
                                                    medium: { inline: medBreakpointSpacing },
                                                    large: { inline: largeBreakpointSpacing },
                                                }, children: jsxs(EGDSTeamLayoutGridContainerBasedSizing, { rows: 1, columns: [`1fr`, `1fr`, `max-content`], space: "twelve", children: [jsx(EGDSTeamLayoutGridContainerBasedSizingItem, { colStart: 1, colEnd: 3, children: jsx(EGDSTeamHeadingBreakpointSizing, { tag: "h2", size: 3, children: carouselTitle }) }), patternButtonLink && patternButtonText && (jsx(Viewport, { children: jsx(ViewMedium, { children: jsx(EGDSTeamLayoutGridContainerBasedSizingItem, { justifySelf: "end", alignSelf: "center", colStart: 3, colEnd: 3, children: getPrimaryButton() }) }) }))] }) }) }) }) }), jsx(EGDSTeamLayoutGridContainerBasedSizingItem, { colSpan: "all", rowStart: 2, rowEnd: 3, children: jsx(EGDSTeamScrimRefactor, { type: "custom-overlay", customColor: scrimCustomColor, children: jsx(EGDSSpacing, { padding: {
                                                blockstart: 'six',
                                                small: { blockend: smallBreakpointSpacing },
                                                medium: { blockend: medBreakpointSpacing },
                                                large: { blockend: largeBreakpointSpacing },
                                            }, children: jsxs("div", { children: [jsx(EGDSTeamCarouselRefactor, { ...carouselProps, children: children }), patternButtonLink && patternButtonText && (jsxs(Viewport, { children: [jsx(ViewSmall, { children: jsx(EGDSSpacing, { margin: {
                                                                        blockstart: 'six',
                                                                        small: { inline: smallBreakpointSpacing },
                                                                        medium: { inline: medBreakpointSpacing },
                                                                        large: { inline: largeBreakpointSpacing },
                                                                    }, children: getPrimaryButton() }) }), jsx(ViewMedium, {})] }))] }) }) }) })] }) }) })] }) }));
};
EGDSTeamPatternFeatureCarousel.displayName = 'EGDSTeamPatternFeatureCarousel';

const EGDSTeamPatternFeatureCardImageProminenceLow = (props) => {
    const { buttonAnalytics, buttonDomRef, buttonOnClick, imageConfiguration = 'trailing', patternImgAltText, patternImgSrc, patternTextHeading, patternTextSubheading, patternButtonLink, patternButtonText, patternBadgeText, patternBadgeTheme = EGDSBadgeStandardThemes.STANDARD, patternHeadingSizeMedLarge = 3, patternHeadingSizeSmall = 4, patternSubheadingTag = 'h3', patternHeadingTag = 'h2', typeStyle, } = props;
    const imageIsLeading = imageConfiguration === 'leading';
    const setAreaConfig = () => imageConfiguration === 'leading'
        ? {
            small: ['text', 'image'],
            medium: ['image text'],
        }
        : {
            small: ['image', 'text'],
            medium: ['text image'],
        };
    const setColumnsConfig = () => {
        const textAreaMinSize = `88x`;
        const textAreaMaxSize = `2fr`;
        const imageAreaSize = `3fr`;
        const textAreaSize = MinMax$1(textAreaMinSize, textAreaMaxSize);
        return imageIsLeading ? [imageAreaSize, textAreaSize] : [textAreaSize, imageAreaSize];
    };
    const smallBreakpointSpacing = 'six';
    const medBreakpointSpacing = 'eight';
    const largeBreakpointSpacing = 'twelve';
    return (jsx(EGDSTeamCardBorderRadiusIncrease, { tag: "section", border: true, backgroundTheme: "secondary", children: jsxs(EGDSLayoutGrid, { areas: setAreaConfig(), columns: { medium: setColumnsConfig() }, children: [jsx(EGDSLayoutGridItem, { area: "text", children: jsx(EGDSSpacing, { padding: {
                            small: {
                                blockstart: imageIsLeading ? smallBreakpointSpacing : 'unset',
                                blockend: imageIsLeading ? 'unset' : smallBreakpointSpacing,
                                inline: smallBreakpointSpacing,
                            },
                            medium: { block: medBreakpointSpacing, inline: medBreakpointSpacing },
                            large: { block: largeBreakpointSpacing, inline: largeBreakpointSpacing },
                        }, children: jsxs(EGDSLayoutFlex, { direction: "column", space: "six", alignItems: "start", justifyContent: "center", children: [patternBadgeText && (jsx(EGDSLayoutFlexItem, { children: jsx(EGDSBadgeStandard, { theme: patternBadgeTheme, text: patternBadgeText, size: "large" }) })), jsx(EGDSLayoutFlexItem, { children: jsxs("hgroup", { children: [jsx(EGDSSpacing, { margin: { blockend: 'three' }, children: jsx(EGDSTeamHeadingBreakpointSizing, { tag: patternHeadingTag, size: { small: patternHeadingSizeSmall, medium: patternHeadingSizeMedLarge }, typeStyle: typeStyle, children: patternTextHeading }) }), jsx(EGDSSubheading, { tag: patternSubheadingTag, children: patternTextSubheading })] }) }), jsx(EGDSLayoutFlexItem, { children: jsx(EGDSPrimaryButton, { tag: "a", domRef: buttonDomRef, analytics: buttonAnalytics, href: patternButtonLink, onClick: buttonOnClick, size: EGDSButtonSize.LARGE, children: patternButtonText }) })] }) }) }), jsx(EGDSLayoutGridItem, { area: "image", alignSelf: "center", children: jsx(EGDSSpacing, { padding: "six", children: jsx("div", { children: jsx(EGDSTeamFigureRefactor, { ratio: EGDSFigureAspectRatioType$1.R3_2, roundcorner: true, children: jsx(EGDSTeamImageRefactor, { placeholderImage: true, alt: patternImgAltText, src: patternImgSrc }) }) }) }) })] }) }));
};
EGDSTeamPatternFeatureCardImageProminenceLow.displayName = 'EGDSTeamPatternFeatureCardImageProminenceLow';

const EGDSTeamPatternFeatureCardImageProminenceMid = (props) => {
    const { buttonAnalytics, buttonDomRef, buttonOnClick, patternImgSrcMedLarge, patternImgSrcSmall, patternImgAltText, patternTextHeading, patternTextSubheading, patternBadgeTheme = EGDSBadgeStandardThemes.STANDARD, patternBadgeText, patternButtonText, patternButtonLink, patternHeadingTag = 'h2', patternSubheadingTag = 'h3', patternHeadingSizeMedLarge = 3, patternHeadingSizeSmall = 4, textCardConfiguration = 'center', typeStyle, } = props;
    const textCardConfigurationIsCenter = textCardConfiguration === 'center';
    const textAreaMinSize = `88x`;
    const textAreaMaxSize = `112x`;
    const imageAreaSpacerMidLargeSize = `3fr`; // Gives (flexible) space for the image at med/large sizes
    return (jsx(EGDSTeamCardBorderRadiusIncrease, { tag: "section", border: { small: true, medium: false, large: false, extra_large: false }, children: jsxs(EGDSTeamLayoutGridContainerBasedSizing, { columns: {
                small: 1,
                medium: [MinMax$1(textAreaMinSize, textAreaMaxSize), imageAreaSpacerMidLargeSize],
            }, rows: {
                small: ['1fr', '1fr'],
                medium: 1,
            }, children: [jsx(EGDSTeamLayoutGridContainerBasedSizingItem, { colSpan: "all", rowStart: { small: textCardConfigurationIsCenter ? 2 : 1, medium: 1 }, rowEnd: { small: textCardConfigurationIsCenter ? -1 : 1, medium: -1 }, children: jsx(EGDSTeamFigureRefactor, { imageFit: "cover", ratio: EGDSFigureAspectRatioType$1.R21_9, children: jsx(EGDSTeamImageRefactor, { placeholderImage: true, src: patternImgSrcMedLarge, alt: patternImgAltText, additionalSources: { sm: patternImgSrcSmall } }) }) }), jsx(EGDSTeamLayoutGridContainerBasedSizingItem, { rowStart: { small: textCardConfigurationIsCenter ? 1 : 2, medium: 1 }, rowEnd: textCardConfigurationIsCenter ? 1 : -1, colStart: 1, colEnd: { small: -1, medium: 1 }, children: jsx(EGDSSpacing, { margin: {
                            medium: { inlinestart: 'eight', block: 'twelve' },
                            large: { inlinestart: 'twelve' },
                        }, children: jsx(EGDSLayoutFlex, { alignItems: textCardConfiguration, children: jsx(EGDSLayoutFlexItem, { children: jsx(EGDSCard, { children: jsx(EGDSSpacing, { padding: "six", children: jsxs(EGDSLayoutFlex, { direction: "column", space: "six", alignItems: "start", children: [patternBadgeText && (jsx(EGDSLayoutFlexItem, { children: jsx(EGDSBadgeStandard, { theme: patternBadgeTheme, text: patternBadgeText, size: "large" }) })), jsx(EGDSLayoutFlexItem, { children: jsxs("hgroup", { children: [jsx(EGDSSpacing, { margin: { blockend: 'three' }, children: jsx(EGDSTeamHeadingBreakpointSizing, { tag: patternHeadingTag, size: { small: patternHeadingSizeSmall, medium: patternHeadingSizeMedLarge }, typeStyle: typeStyle, children: patternTextHeading }) }), jsx(EGDSSubheading, { tag: patternSubheadingTag, children: patternTextSubheading })] }) }), jsx(EGDSLayoutFlexItem, { children: jsx(EGDSPrimaryButton, { tag: "a", domRef: buttonDomRef, analytics: buttonAnalytics, href: patternButtonLink, onClick: buttonOnClick, size: EGDSButtonSize.LARGE, children: patternButtonText }) })] }) }) }) }) }) }) })] }) }));
};
EGDSTeamPatternFeatureCardImageProminenceMid.displayName = 'EGDSTeamPatternFeatureCardImageProminenceMid';

const EGDSTeamPatternFeatureCardImageProminenceHigh = (props) => {
    const { buttonAnalytics, buttonDomRef, buttonOnClick, patternImgSrcSmall, patternImgSrcMedLarge, patternImgAltText, textBlockConfiguration = 'end', patternButtonText, patternButtonLink, patternBadgeText, patternBadgeTheme = EGDSBadgeStandardThemes.STANDARD, patternTextSubheading, patternTextHeading, patternHeadingTag = 'h2', patternSubheadingTag = 'h3', patternHeadingSizeMedLarge = 3, patternHeadingSizeSmall = 4, scrimCustomColor = { h: 231, s: 40, l: 16 }, typeStyle, } = props;
    const smallBreakpointSpacing = 'six';
    const medBreakpointSpacing = 'eight';
    const largeBreakpointSpacing = 'twelve';
    const badgeAndTitle = () => (jsxs(Fragment, { children: [patternBadgeText && (jsx(EGDSSpacing, { margin: {
                    blockstart: 'twelve',
                    small: { inlinestart: smallBreakpointSpacing, inlineend: 'unset' },
                    medium: { inlinestart: medBreakpointSpacing, inlineend: 'unset' },
                    large: { inlinestart: largeBreakpointSpacing, inlineend: 'unset' },
                }, children: jsx(EGDSBadgeStandard, { theme: patternBadgeTheme, text: patternBadgeText, size: "large" }) })), jsx(EGDSSpacing, { margin: {
                    blockstart: 'six',
                    small: { inlinestart: smallBreakpointSpacing, inlineend: 'unset' },
                    medium: { inlinestart: medBreakpointSpacing, inlineend: 'unset' },
                    large: { inlinestart: largeBreakpointSpacing, inlineend: 'unset' },
                }, children: jsx(EGDSTeamHeadingBreakpointSizing, { tag: patternHeadingTag, size: { small: patternHeadingSizeSmall, medium: patternHeadingSizeMedLarge }, typeStyle: typeStyle, children: patternTextHeading }) })] }));
    const subtitleAndButton = () => (jsxs(Fragment, { children: [jsx(EGDSSpacing, { padding: {
                    blockstart: 'three',
                }, margin: {
                    small: { inlinestart: smallBreakpointSpacing, inlineend: 'unset' },
                    medium: { inlinestart: medBreakpointSpacing, inlineend: 'unset' },
                    large: { inlinestart: largeBreakpointSpacing, inlineend: 'unset' },
                }, children: jsx(EGDSTeamSubheadingBreakpointSizing, { tag: patternSubheadingTag, children: patternTextSubheading }) }), jsx(EGDSSpacing, { margin: {
                    blockstart: 'six',
                    small: { inlinestart: smallBreakpointSpacing, inlineend: 'unset', blockend: smallBreakpointSpacing },
                    medium: { inlinestart: medBreakpointSpacing, inlineend: 'unset', blockend: medBreakpointSpacing },
                    large: { inlinestart: largeBreakpointSpacing, inlineend: 'unset', blockend: largeBreakpointSpacing },
                }, children: jsx(EGDSPrimaryButton, { tag: "a", domRef: buttonDomRef, analytics: buttonAnalytics, href: patternButtonLink, onClick: buttonOnClick, size: EGDSButtonSize.LARGE, children: patternButtonText }) })] }));
    const textContent = () => (jsx(EGDSTeamLayoutGridContainerBasedSizing, { columns: 1, rows: 1, blockSize: "full_size", children: jsx(EGDSTeamLayoutGridContainerBasedSizingItem, { alignSelf: textBlockConfiguration, rowSpan: "all", children: jsxs(EGDSLayoutPosition, { type: "relative", children: [jsx(EGDSTeamScrimRefactor, { type: "custom-fade-bottom", typeAtBreakpoint: { small: 'custom-fade-bottom', medium: 'empty' }, children: badgeAndTitle() }), jsx(EGDSTeamScrimRefactor, { type: "custom-overlay", typeAtBreakpoint: { small: 'custom-overlay', medium: 'empty' }, children: subtitleAndButton() })] }) }) }));
    const textAreaMinSize = `88x`;
    const textAreaMaxSize = `112x`;
    const imageAreaSpacerSmallSize = `212px`; // Gives (fixed) space for the image at small sizes
    const imageAreaSpacerMidLargeSize = `3fr`; // Gives (flexible) space for the image at med/large sizes
    const extraScrimColumnSize = `96px`;
    const hideExtraScrimColumnSize = `0px`;
    return (jsx(EGDSTeamCardBorderRadiusIncrease, { tag: "section", children: jsxs(EGDSTeamLayoutGridContainerBasedSizing, { columns: {
                small: [`1fr`, hideExtraScrimColumnSize],
                medium: [MinMax$1(textAreaMinSize, textAreaMaxSize), extraScrimColumnSize, imageAreaSpacerMidLargeSize],
            }, rows: {
                small: [imageAreaSpacerSmallSize, '1fr'],
                medium: ['1fr'],
            }, children: [jsx(EGDSTeamLayoutGridContainerBasedSizingItem, { colSpan: "all", rowStart: 1, rowEnd: -1, children: jsx(EGDSTeamFigureRefactor, { imageFit: "cover", ratio: EGDSFigureAspectRatioType$1.R21_9, children: jsx(EGDSTeamImageRefactor, { blankDefault: true, src: patternImgSrcMedLarge, alt: patternImgAltText, additionalSources: { sm: patternImgSrcSmall }, customBlankBackgroundColor: `hsl(${scrimCustomColor.h}, ${scrimCustomColor.s}%, ${scrimCustomColor.l}%)` }) }) }), jsx(EGDSTeamLayoutGridContainerBasedSizingItem, { rowStart: { small: 2, medium: 1 }, rowEnd: -1, colStart: 1, colEnd: { small: -1, medium: 1 }, children: jsx("div", { children: jsx(EGDSTeamScrimRefactor, { type: "custom-overlay", typeAtBreakpoint: { small: 'empty', medium: 'custom-overlay' }, customColor: scrimCustomColor, children: textContent() }) }) }), jsx(EGDSTeamLayoutGridContainerBasedSizingItem, { rowSpan: "all", colStart: 2, colEnd: 2, children: jsx("div", { children: jsx(EGDSTeamScrimRefactor, { type: "custom-leading", customColor: scrimCustomColor }) }) })] }) }));
};
EGDSTeamPatternFeatureCardImageProminenceHigh.displayName = 'EGDSTeamPatternFeatureCardImageProminenceHigh';

export { Carousel, CarouselPaginationDots, EGDSCardAspectRatios, EGDSCardBackgroundThemes, EGDSCardContentSectionBorders, EGDSCardContentSectionPaddings, EGDSCardFeaturedHeaderTitleTags, EGDSCardPlaceholderAspectRatios, EGDSCardPlaceholderStartPhases, EGDSCardRoundCorners, EGDSCardTags, EGDSFigureAspectRatioType, EGDSHeadingTags$1 as EGDSHeadingTags, EGDSLocalShimmer, EGDSLocalThemeProvider, EGDSLocalThemedBadge, EGDSLocalThemedButton, EGDSLocalThemedButtonSize, EGDSLocalThemedButtonTheme, EGDSLocalThemedCard, EGDSLocalThemedHeading, EGDSLocalThemedIcon, EGDSLocalThemedParagraph, EGDSLocalThemedPrimaryButton, EGDSLocalThemedSecondaryButton, EGDSLocalThemedSheet, EGDSLocalThemedTertiaryButton, EGDSLocalThemedText, EGDSTeamAnimatedMark, EGDSTeamBlockLink, EGDSTeamCardBorderRadiusIncrease, EGDSTeamCarouselRefactor, EGDSTeamCarouselRefactorBreakPointSizes, EGDSTeamCarouselRefactorItem, EGDSTeamCarouselRefactorItemList, EGDSTeamCarouselRefactorLocalAnalyticsIdType, EGDSTeamCarouselRefactorNav, EGDSTeamCarouselRefactorPaginationDots, EGDSTeamFigureRefactor, EGDSTeamHeadingBreakpointSizing, EGDSTeamImageRefactor, EGDSTeamLayoutGridContainerBasedSizing, EGDSTeamLayoutGridContainerBasedSizingAligns, EGDSTeamLayoutGridContainerBasedSizingAutoFlows, EGDSTeamLayoutGridContainerBasedSizingBlockSizes, EGDSTeamLayoutGridContainerBasedSizingColumnRows, EGDSTeamLayoutGridContainerBasedSizingItem, EGDSTeamLayoutGridContainerBasedSizingItemPlaceSelfs, EGDSTeamLayoutGridContainerBasedSizingPlaces, EGDSTeamLayoutGridContainerBasedSizingSpans, EGDSTeamPatternFeatureCardImageProminenceHigh, EGDSTeamPatternFeatureCardImageProminenceLow, EGDSTeamPatternFeatureCardImageProminenceMid, EGDSTeamPatternFeatureCarousel, EGDSTeamScrimRefactor, EGDSTeamScrimRefactorColorType, EGDSTeamScrimRefactorType, EGDSTeamSubheadingBreakpointSizing, EgdsSizeCustomProp, EgdsSizingLengths, FitContent, IsEgdsSize, IsFlexibleEgdsSize, MakeEgdsSizingLength, MaketrackItem, MinMax, Repeat, isAutoRepeatGrid, isSmallKey, withEGDSTeamLayoutGridContainerBasedSizing };
//# sourceMappingURL=index.esm.js.map
